webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export yxEncript */
/* unused harmony export yxDecript */
/* unused harmony export getUrlArgument */
/* unused harmony export getCss */
/* unused harmony export strlen */
/* unused harmony export loadImages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return os; });
/* unused harmony export convertImgTobase64 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterData; });
/* unused harmony export headTime */
/* unused harmony export editHistoryUrl */
/* unused harmony export toThousands */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return randomString; });
/* unused harmony export moneyFormat */
/* unused harmony export dateFmt */
/* unused harmony export isWeixinBrowser */
/* unused harmony export setTitle */
/* unused harmony export isEmpty */
/* unused harmony export getBankName */
/* unused harmony export getRequest */
/* unused harmony export HTMLEncode */
/* unused harmony export HTMLDecode */
/* unused harmony export getParam */
/* unused harmony export getComputedStyle */
/* unused harmony export respHandle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_index_js__ = __webpack_require__(206);
var _this = this;



var yxEncript = function yxEncript(str) {
    function base64Encode(input) {
        var rv;
        rv = encodeURIComponent(input);
        rv = unescape(rv);
        rv = window.btoa(rv);
        return rv;
    }
    var result = base64Encode(str);
    result = result.split('').reverse().join('');
    return result;
};

var yxDecript = function yxDecript(str) {
    var result = str.split('').reverse().join('');
    function base64Decode(input) {
        var rv = window.atob(input);
        rv = escape(rv);
        rv = decodeURIComponent(rv);
        return rv;
    }
    return base64Decode(result);
};

var getUrlArgument = function getUrlArgument(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

var getCss = function getCss(obj, attr) {
    var i = parseFloat(obj.currentStyle ? obj.currentStyle[attr] : document.defaultView.getComputedStyle(obj, false)[attr]);
    var values = i ? i : 0;
    if (attr == "opacity") {
        values = Math.round(values * 100);
    }
    return values;
};

var strlen = function strlen(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);

        if (c >= 0x0001 && c <= 0x007e || 0xff60 <= c && c <= 0xff9f) {
            len++;
        } else {
            len += 2;
        }
    }
    return len;
};

var loadImages = function loadImages(id, fn) {
    var allImg = document.getElementById(id).getElementsByTagName('img');
    var imgSrcArr = [];
    var imgSuc = 0;
    var imgTimer = '';
    var allImgNum = 0;
    for (var i = 0; i < allImg.length; i++) {
        if (allImg[i].src && allImg[i].src.indexOf('base64') < 0 && allImg[i].src.indexOf('images') > 0) {
            allImgNum++;
            imgSrcArr.push(allImg[i].src);
        }
    }
    for (var i = 0; i < allImgNum; i++) {
        var oImg = new Image();
        oImg.src = imgSrcArr[i];
        oImg.onload = function () {
            imgSuc++;

            if (imgSuc == allImgNum) {
                clearTimeout(imgTimer);
                imgTimer = setTimeout(function () {
                    if (fn) fn.call(_this);
                }, 100);
            }
        };
    }
};

var os = function os() {
    var ua = window.navigator.userAgent;
    var isWeibo = /WeiBo/i.test(ua),
        isQQ = /QQ/i.test(ua),
        isWechat = /MicroMessenger/i.test(ua),
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua),
        isIos = /(?:iPhone)/.test(ua) && !isTablet,
        isBrowser = !isWeibo && !isQQ && !isWechat,
        isPc = !isWeibo && !isQQ && !isWechat && !isAndroid && !isIos;
    return {
        isWeibo: isWeibo,
        isQQ: isQQ,
        isWechat: isWechat,
        isAndroid: isAndroid,
        isIos: isIos,
        isTablet: isTablet,
        isBrowser: isBrowser,
        isPc: isPc
    };
};

var convertImgTobase64 = function convertImgTobase64(url, callback, outputFormat) {
    var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'),
        img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || 'image/png');
        callback.call(this, dataURL);
        canvas = null;
    };
    img.src = url;
};

var filterData = function filterData(json) {
    for (var attr in json) {
        if (json[attr] === '' || json[attr] === undefined) {
            delete json[attr];
        }
    }
    return json;
};

var headTime = function headTime(fn) {
    var xhr = new XMLHttpRequest();

    xhr.open("get", "/");

    xhr.onreadystatechange = function () {
        var time = null,
            curDate = null;
        if (xhr.readyState === 2) {
            time = xhr.getResponseHeader("Date");

            curDate = new Date(time);
            if (fn) fn.call(_this, curDate.getTime());
        }
    };
    xhr.send(null);
};

var editHistoryUrl = function editHistoryUrl(str) {
    var url = window.location.href;
    url = url.substring(0, url.lastIndexOf('/') + 1);
    url = url + str;
    window.history.pushState('', '', url);
};

var toThousands = function toThousands(num) {
    return (num || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

var getNow = function getNow() {
    var date = new Date();
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    var now = Y + M + D + h + m + s;
    return now;
};

var randomString = function randomString(len) {
    len = len || 6;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZ2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd + Date.now();
};

var moneyFormat = function moneyFormat(nStr) {
    if (nStr === 0 || nStr === "0") {
        return "0.00";
    }

    if (!nStr || isNaN(nStr)) {
        return "";
    }

    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '.00';
    if (x2.length < 3) {
        x2 += "00";
    }
    x2 = x2.substring(0, 3);
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
};

var dateFmt = function dateFmt(date, format) {
    if ('number' === typeof date) {
        date = new Date(date);
    }
    if (format === undefined) {
        format = date;
        date = new Date();
    }
    var map = {
        'M': date.getMonth() + 1,
        'd': date.getDate(),
        'h': date.getHours(),
        'm': date.getMinutes(),
        's': date.getSeconds(),
        'q': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds() };
    format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
        var v = map[t];
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v;
                v = v.substr(v.length - 2);
            }
            return v;
        } else if (t === 'y') {
            return (date.getFullYear() + '').substr(4 - all.length);
        }
        return all;
    });
    return format;
};

var isWeixinBrowser = function isWeixinBrowser() {
    return (/MicroMessenger/i.test(window.navigator.userAgent)
    );
};

var setTitle = function setTitle(title) {
    setTimeout(function () {
        document.title = title;
        var iframe = document.createElement('iframe');
        iframe.src = '1px4wx.gif';
        iframe.onload = function () {
            setTimeout(function () {
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    }, 0);
};

var isEmpty = function isEmpty(obj) {
    if (!obj) return true;

    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            return false;
        }
    }
    return true;
};

var getBankName = function getBankName(bankcode) {
    if (!bankcode) return '';
    switch (bankcode) {
        case 'ICBC':
            return '工商银行';
        case 'ABC':
            return '农业银行';
        case 'BOC':
            return '中国银行';
        case 'CCB':
            return '建设银行';
        case 'BCM':
            return '交通银行';
        case 'CITIC':
            return '中信银行';
        case 'CEB':
            return '光大银行';
        case 'HXB':
            return '华夏银行';
        case 'CMBC':
            return '民生银行';
        case 'PINGAN':
            return '平安银行';
        case 'CMB':
            return '招商银行';
        case 'CIB':
            return '兴业银行';
        case 'SPDB':
            return '浦发银行';
        case 'PSBOC':
            return '邮储银行';
        case 'GDB':
            return '广发银行';
        case 'BOS':
            return '上海银行';
        case 'BOB':
            return '北京银行';
    }
};

var getRequest = function getRequest(str) {
    var url = window.location + '';
    if (str) {
        url = str;
    }
    url = decodeURIComponent(url);

    var theRequest = new Object();

    var index = url.indexOf('?');

    if (index != -1) {
        var _str = url.substr(index + 1);
        var strs = _str.split('&');
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
    }
    return theRequest;
};

var HTMLEncode = function HTMLEncode(html) {
    var temp = document.createElement("div");
    temp.textContent != null ? temp.textContent = html : temp.innerText = html;
    var output = temp.innerHTML;
    temp = null;
    return output;
};

var HTMLDecode = function HTMLDecode(html) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
};

var getParam = function getParam(str, name) {
    var match = name + '=';
    var i = str.indexOf(name + '=') + match.length;
    var r = str.substr(i);
    return r;
};

function getComputedStyle(el, key) {
    var computedStyle = window.getComputedStyle(el);
    return computedStyle[key] || '';
}

var respHandle = function respHandle(resp) {
    if (!resp.ok) {
        return -1;
    }
    if (resp.status == '200') {
        if (resp.body.status == '200') {
            return 0;
        }

        if (resp.body.status == '504') {
            var phone = store.get('_phoneNo');
            store.init();
            if (phone == '' || phone == 'null' || !phone) {
                window.location.hash = '#!/hello';
                return 4;
            }
            store.set({
                _phoneNo: phone
            });
            window.location.hash = '#!/login';
            return 3;
        }

        return 1;
    } else {
            return 2;
        }
};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


var ENV = '';

var NowApiDianDian = '';
var NowApiCms = '';
var NowApiDurex = '';

switch (ENV) {
    case '-test':
        if (false) {
            NowApiDianDian = 'http://127.0.0.1:8087/diandian';
            NowApiCms = 'http://127.0.0.1:8087/ddcms';
            NowApiDurex = 'http://127.0.0.1:8087/durex';
        } else {
            NowApiDianDian = 'https://diandian-test2.zhongan.com/noah/apiAction.do';
            NowApiCms = 'https://dd-cms-test.zhongan.com/apiAction.do';
            NowApiDurex = 'https://aucen-test.zhongan.com';
        }
        break;
    case '-uat':
        NowApiDianDian = 'https://diandian-mics-uat.zhongan.com/apiAction.do';
        NowApiCms = 'https://cms-uat.zhongan.com/apiAction.do';
        NowApiDurex = 'https://aucen-uat.zhongan.com';
        break;
    case '':
        NowApiDianDian = 'https://finance.diandian.com.cn/apiAction.do';
        NowApiCms = 'https://cms.diandian.com.cn/apiAction.do';
        NowApiDurex = 'https://aucen.zhongan.com';
        break;
}

module.exports = {
    ENV: ENV,
    API_ROOT: NowApiDianDian,
    API_CMS: NowApiCms,
    API_DUREX: NowApiDurex
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(330),
  /* scopeId */
  "data-v-1ae48279",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* scopeId */
  "data-v-1ca45c07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  "data-v-48615b88",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(343),
  /* scopeId */
  "data-v-1a4fed49",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_shence__ = __webpack_require__(161);









var zaApi = __WEBPACK_IMPORTED_MODULE_4__config___default.a.API_ROOT;
var cmsApi = __WEBPACK_IMPORTED_MODULE_4__config___default.a.API_CMS;

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
    axios: function axios(data) {
        var method = data.method || 'post';

        var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
            'partnerNo': 'NYDDXJD',
            'reqNo': Object(__WEBPACK_IMPORTED_MODULE_6__utils_tool__["d" /* randomString */])(20),
            'reqDate': Object(__WEBPACK_IMPORTED_MODULE_6__utils_tool__["b" /* getNow */])(),
            'apiVersion': '1.0.0',
            'versionCode': '230',
            'platform': 'h5',
            'systemFrom': 'h5',
            'deviceId': __WEBPACK_IMPORTED_MODULE_7__utils_shence__["a" /* default */].store.getDistinctId(),
            'anonymousId': __WEBPACK_IMPORTED_MODULE_7__utils_shence__["a" /* default */].store.getDistinctId()
        }, data.param);
        data.param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(p);

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a[method](zaApi, __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(data)).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    ddcms: function ddcms(data) {
        var method = data.method || 'post';

        var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
            'partnerNo': 'NYDDXJD',
            'reqNo': Object(__WEBPACK_IMPORTED_MODULE_6__utils_tool__["d" /* randomString */])(20),
            'reqDate': Object(__WEBPACK_IMPORTED_MODULE_6__utils_tool__["b" /* getNow */])(),
            'apiVersion': '1.0.0'
        }, data.param);
        data.param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(p);

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a[method](cmsApi, __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(data)).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error);
            });
        });
    }
});

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);


var url = '';
switch (__WEBPACK_IMPORTED_MODULE_1__config___default.a.ENV) {
	case '-test':
	case '-uat':
		url = 'https://sensordata.zhongan.com/sa?project=diandian_test&token=diandian123';
		break;
	case '':
		url = 'https://sensordata.zhongan.com/sa?project=diandian&token=gQusgVLGPNx6xsjHhQ';
		break;
}

__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript___default.a.init({
	server_url: url,
	name: 'sa',
	heatmap_url: 'https://static.sensorsdata.cn/sdk/1.9.11/heatmap.min.js',

	heatmap: {
		isTrackLink: false,

		loadTimeout: 3000
	},

	use_app_track: true,
	use_client_time: true,
	is_single_page: true,
	show_log: true,

	web_url: 'http://sensordata.zhonganonline.com'
});

__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript___default.a.quick('autoTrack');

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript___default.a);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-1.d5358fe.png";

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_init_scss__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_scss_init_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_scss_init_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_shence__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_v_loading_index_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_v_toast_index_js__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__storage_storage_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta_info__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_meta_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_meta_info__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.sa = __WEBPACK_IMPORTED_MODULE_7__utils_shence__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.debug = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.diandianAndroidDownLoadUrl = 'https://dd-cms.zhongan.com/apkManagerAction/redirectLoadApk?key=071626cb702d4283b1d7a123b167031a&a=1.apk';


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__components_v_loading_index_js__["a" /* default */], { container: '#app' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__components_v_toast_index_js__["a" /* default */], { container: '#app' });


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$storage = __WEBPACK_IMPORTED_MODULE_10__storage_storage_js__["a" /* default */];


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_meta_info___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(DurexCaptchaJs.default, {
    baseURL: __WEBPACK_IMPORTED_MODULE_6__config___default.a.API_DUREX
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    if (to.name === null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isIos || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isAndroid || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isTablet) {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/flatindexmobile');
        } else {
            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace('/flatindex');
        }
    }

    next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
    }
});

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  "data-v-4b464f51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {



/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


var key = '_za_param';

var storage = {
    init: function init() {
        var json = localStorage.getItem(key);
        if (!json) {
            json = '';
        }
        var no = '';
        var uid = '';
        var channel = '';
        var guard = '';
        var businessInfo = '';
        if (json != '') {
            json = JSON.parse(json);
            if (json.hasOwnProperty('_ApplyOrderNo')) {
                no = json._ApplyOrderNo;
            }
            if (json.hasOwnProperty('_UID')) {
                uid = json._UID;
            }
            if (json.hasOwnProperty('_channel')) {
                channel = json._channel;
            }
            if (json.hasOwnProperty('guard')) {
                guard = json.guard;
            }
            if (json.hasOwnProperty('_BusinessInfo')) {
                businessInfo = json._BusinessInfo;
            }
        }
        var init = {
            token: '',
            _Apply: '0',
            _ApplyStatus: '0',
            _CreditCardInfo: '0',
            _ApplyOrderNo: no,
            _UID: uid,
            _channel: channel,
            _BusinessInfo: businessInfo,
            guard: guard
        };
        init = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(init);
        localStorage.setItem(key, init);
    },
    status: function status() {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            return false;
        }
        json = JSON.parse(json);
        if (json.token == '') {
            return false;
        } else {
            return true;
        }
    },
    set: function set(data) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            json = '{}';
        }
        json = JSON.parse(json);
        json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, json, data);
        json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(json);
        localStorage.setItem(key, json);
    },
    get: function get(name) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            return '';
        }
        json = JSON.parse(json);
        if (json[name] != '0' && (!json[name] || json[name] == '')) {
            return '';
        }
        return json[name];
    },
    remove: function remove(name) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            return '';
        }
        json = JSON.parse(json);
        delete json[name];
        json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(json);
        localStorage.setItem(key, json);
    }
};

/* unused harmony default export */ var _unused_webpack_default_export = (storage);

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Init__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Init___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Init__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Hello__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Index__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_AboutDetail__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_AboutDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_AboutDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_flatindex__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_flatindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_flatindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_flatindexmobile2__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_flatindexmobile2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_flatindexmobile2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_flatindexmobile__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_flatindexmobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_flatindexmobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_AboutUs__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_AboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_AboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_AboutUsMobile__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_AboutUsMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_AboutUsMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_HelpCenter__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_HelpCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_HelpCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_HelpCenterMobile__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_HelpCenterMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_HelpCenterMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Cooperate__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Cooperate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Cooperate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_CooperateMobile__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_CooperateMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_CooperateMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_DdGo__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_DdGo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_DdGo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Declare__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Declare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Declare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Pdxy__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Pdxy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Pdxy__);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);



















/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/index',
        name: 'index',
        component: __WEBPACK_IMPORTED_MODULE_5__views_Index___default.a
    }, {
        path: '/hello',
        name: 'hello',
        component: __WEBPACK_IMPORTED_MODULE_4__views_Hello___default.a
    }, {
        path: '/aboutdetail',
        name: 'aboutdetail',
        component: __WEBPACK_IMPORTED_MODULE_6__views_AboutDetail___default.a
    }, {
        path: '/flatindex',
        name: 'flatindex',
        component: __WEBPACK_IMPORTED_MODULE_7__views_flatindex___default.a
    }, {
        path: '/flatindexmobile2',
        name: 'flatindexmobile2',
        component: __WEBPACK_IMPORTED_MODULE_8__views_flatindexmobile2___default.a
    }, {
        path: '/flatindexmobile',
        name: 'flatindexmobile',
        component: __WEBPACK_IMPORTED_MODULE_9__views_flatindexmobile___default.a
    }, {
        path: '/aboutus',
        name: 'aboutus',
        component: __WEBPACK_IMPORTED_MODULE_10__views_AboutUs___default.a
    }, {
        path: '/aboutusmobile',
        name: 'aboutusmobile',
        component: __WEBPACK_IMPORTED_MODULE_11__views_AboutUsMobile___default.a
    }, {
        path: '/helpcenter',
        name: 'helpcenter',
        component: __WEBPACK_IMPORTED_MODULE_12__views_HelpCenter___default.a
    }, {
        path: '/cooperate',
        name: 'cooperate',
        component: __WEBPACK_IMPORTED_MODULE_14__views_Cooperate___default.a
    }, {
        path: '/helpcentermobile',
        name: 'helpcentermobile',
        component: __WEBPACK_IMPORTED_MODULE_13__views_HelpCenterMobile___default.a
    }, {
        path: '/cooperatemobile',
        name: 'cooperatemobile',
        component: __WEBPACK_IMPORTED_MODULE_15__views_CooperateMobile___default.a
    }, {
        path: '/ddgo',
        name: 'ddgo',
        component: __WEBPACK_IMPORTED_MODULE_16__views_DdGo___default.a
    }, {
        path: '/declare',
        name: 'declare',
        component: __WEBPACK_IMPORTED_MODULE_17__views_Declare___default.a
    }, {
        path: '/pdxy',
        name: 'pdxy',
        component: __WEBPACK_IMPORTED_MODULE_18__views_Pdxy___default.a
    }]
}));

/***/ }),
/* 219 */,
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {
            msg: ''
        };
    },
    mounted: function mounted() {},
    methods: function methods() {}
});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "parent"
    }
  })])
}]}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  "data-v-7cf7a9be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
    },
    data: function data() {
        var _vue = this;
        return {
            isFixed: false,
            swiperOption: {
                direction: 'vertical',
                mousewheel: true,
                touchRatio: 0.5,
                resistanceRatio: 0,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {
                        if (this.activeIndex == 1) {
                            _vue.wavesHandle();
                        }
                    }
                }
            }
        };
    },

    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    created: function created() {
        document.title = '点点';
        this.swiperOption.height = document.documentElement.clientHeight || document.body.clientHeight;
    },
    mounted: function mounted() {
        console.log(this.swiper);
        this.resetHeight();
        this.scrollHandle();
    },

    methods: {
        resetHeight: function resetHeight() {
            var clienHeight = document.documentElement.clientHeight || document.body.clientHeight;
            this.$refs.mySwiper.$el.style.height = clienHeight + 'px';
        },
        scrollHandle: function scrollHandle() {
            var _this = this;

            window.addEventListener('scroll', function () {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;
                console.log(nowScrollTop);
                if (nowScrollTop > 0) {
                    _this.isFixed = true;
                } else {
                    _this.isFixed = false;
                }
            }, false);
        },
        wavesHandle: function wavesHandle() {
            var oWaves = this.$refs.waves;
            var ctx = oWaves.getContext('2d');
            var w, h;
            oWaves.width = w = document.documentElement.clientWidth;
            oWaves.height = h = document.documentElement.clientHeight;

            var timer = null;
            var x = 0;
            var y = 0;

            var mind = 0;
            var lastY = 0;
            var maxHeight = 200;
            var wavesHeight = maxHeight;

            var wavesJson = [{
                swing: 50,
                speedX: 0.7,
                x: 0,
                y: 0,
                waves: 280,
                color: 'rgba(196, 146, 194, 0.6)'
            }, {
                swing: 30,
                speedX: 2,
                x: 0,
                y: 0,
                waves: 230,
                color: 'rgba(228, 225, 154, 0.6)'
            }, {
                swing: 45,
                speedX: 1.5,
                x: 0,
                y: 0,
                waves: 150,
                color: 'rgba(114, 163, 201, 0.6)'
            }];

            function runWaves() {
                ctx.clearRect(0, 0, oWaves.offsetWidth * 2, oWaves.offsetHeight);

                maxHeight *= 0.975;
                maxHeight < 1 ? maxHeight = 0 : maxHeight;
                var nowHeight = wavesHeight - maxHeight;
                var scale = nowHeight / wavesHeight;


                mind++;
                var mould = Math.PI / 180 * mind;


                for (var i = 0; i < wavesJson.length; i++) {
                    var s = wavesJson[i];

                    s.x += s.speedX;
                    if (s.x >= w / 2) {
                        s.x = 0;
                    }

                    var sin = Math.sin(mould) * s.swing;
                    var cos = Math.cos(mould) * s.swing;
                    var wavesNum = s.waves * scale + cos;
                    var cHeight = h - nowHeight + sin;

                    ctx.beginPath();
                    ctx.moveTo(0 - s.x, cHeight);
                    ctx.bezierCurveTo(w / 4 - s.x, cHeight - wavesNum, w / 4 - s.x, cHeight + wavesNum, w / 2 - s.x, cHeight);
                    ctx.bezierCurveTo(w / 4 * 3 - s.x, cHeight - wavesNum, w / 4 * 3 - s.x, cHeight + wavesNum, w - s.x, cHeight);
                    ctx.bezierCurveTo(w + w / 4 - s.x, cHeight - wavesNum, w + w / 4 - s.x, cHeight + wavesNum, w + w / 2 - s.x, cHeight);

                    ctx.lineTo(w + w / 2 - s.x, h);
                    ctx.lineTo(0 - s.x, h);
                    ctx.closePath();

                    ctx.fillStyle = s.color;
                    ctx.fill();
                }

                timer = requestAnimationFrame(runWaves);
            }
            runWaves();
        }
    }
});

/***/ }),
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-home"
  }, [_c('div', {
    staticClass: "dh-nav",
    class: {
      'nav-fixed': _vm.isFixed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "dh-1"
  }, [_vm._v("\n                I'm Slide 1\n            ")]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "dh-2"
  }, [_vm._v("\n                I'm Slide 2\n                "), _c('canvas', {
    ref: "waves",
    attrs: {
      "width": "500px",
      "height": "500px",
      "id": "box"
    }
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "dh-3"
  }, [_vm._v("\n                I'm Slide 3\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  "data-v-4a0e3b21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            isDs_1: true,
            isDs_1_bg: true,
            isDs_1_bg_rs: false,
            isDs_2: false,
            isDs_2_bg: false,
            isDs_2_bg_rs: false,
            isDs_3: false,
            isDs_3_bg: false,
            isDs_3_bg_rs: false,
            isDs_4: false,
            isDs_4_bg: false,
            isDs_4_bg_rs: false,
            isDs_5: false,
            isDs_5_bg: false,
            isDs_5_bg_rs: false,
            nowIndex: 0,
            page: 5,
            timer: null,
            isMoveing: true,
            isFixed: false,
            isDsRadio: false,
            isQrcode: false,
            autoPage: 6000,
            nowDownloadUrl: '',
            swiperOption: {
                speed: 450,
                height: 420,

                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {},
                    transitionEnd: function transitionEnd() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start();
                        }
                    }
                }
            }
        };
    },

    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    watch: {
        nowIndex: function nowIndex(n, o) {
            var _this = this;

            this['isDs_' + eval(o + 1) + ''] = false;
            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
                _this['isDs_' + eval(n + 1) + ''] = true;
                _this['isDs_' + eval(n + 1) + '_bg'] = true;
                _this['isDs_' + eval(n + 1) + '_bg_rs'] = false;

                _this['isDs_' + eval(o + 1) + '_bg'] = false;
                _this['isDs_' + eval(o + 1) + '_bg_rs'] = true;

                _this.parallax();
                _this.isMoveing = true;
            }, 1000);

            cancelAnimationFrame(this.aMPage[o].raf);
            this.setCss3(this.aMPage[o], {
                transform: 'translate3d(-100%,0,0)'
            });
            this.moveBar(this.aMPage[n], 0, 6000);
        }
    },
    created: function created() {
        document.title = '点点-让生活好一点';
        var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        this.bannerPcHeight = clientHeight - 80;
        this.bannerPcHeight = this.bannerPcHeight < 678 ? 678 : this.bannerPcHeight;

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isIos || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isAndroid) {
            this.isMobile = true;
        } else {
            this.isPc = true;
        }
    },
    mounted: function mounted() {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isIos || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isAndroid) {} else {
            this.pfx();
            this.initElement();
            this.resetHeight();
            this.parallax();
        }

        console.log(this.transform);
    },

    methods: {
        pfx: function pfx() {
            var prefix = function () {
                var tempDom = document.createElement('div').style,
                    prefixStrArr = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                    sPre;
                for (var i = 0; i < prefixStrArr.length; i++) {
                    if (prefixStrArr[i] + 'ransform' in tempDom) {
                        sPre = prefixStrArr[i].substring(0, prefixStrArr[i].length - 1);
                        window.cssPrefix = sPre ? sPre : '';
                        window.css_Prefix = sPre ? '-' + sPre.toLowerCase() + '-' : '';
                    }
                }
                tempDom = null;
                return function (style) {
                    if (sPre === '') return style;
                    style = style.charAt(0).toUpperCase() + style.substring(1);
                    return sPre + style;
                };
            }();
            var _vTransitionEnd = {
                '': 'transitionend',
                'webkit': 'webkitTransitionEnd',
                'Moz': 'transitionend',
                'O': 'otransitionend',
                'ms': 'MSTransitionEnd'
            };
            this.transform = prefix('transform');
        },
        parallax: function parallax() {
            var scene = document.getElementById('scene');
            var parallaxInstance = new Parallax(scene, {});
            parallaxInstance.friction(0.075, 0.075);
            parallaxInstance.origin(1, 1);

            var scene1_2 = document.getElementById('scene-sp-1');
            var parallaxInstance1_2 = new Parallax(scene1_2);
            parallaxInstance1_2.friction(0.075, 0.075);

            var scene2 = document.getElementById('scene_2');
            var parallaxInstance2_1 = new Parallax(scene2);
            parallaxInstance2_1.friction(0.075, 0.075);

            var scene2_2 = document.getElementById('scene-sp-2');
            var parallaxInstance2_2 = new Parallax(scene2_2);
            parallaxInstance2_2.friction(0.075, 0.075);

            var scene3 = document.getElementById('scene_3');
            var parallaxInstance3_1 = new Parallax(scene3);
            parallaxInstance3_1.friction(0.075, 0.075);

            var scene3_2 = document.getElementById('scene-sp-3');
            var parallaxInstance3_2 = new Parallax(scene3_2);
            parallaxInstance3_2.friction(0.075, 0.075);

            var scene4 = document.getElementById('scene_4');
            var parallaxInstance4 = new Parallax(scene4);
            parallaxInstance4.friction(0.075, 0.075);

            var scene4_1 = document.getElementById('scene-sp-4');
            var parallaxInstance4_1 = new Parallax(scene4_1);
            parallaxInstance4_1.friction(0.075, 0.075);

            var scene5 = document.getElementById('scene_5');
            var parallaxInstance5 = new Parallax(scene5);
            parallaxInstance5.friction(0.075, 0.075);

            var scene5_1 = document.getElementById('scene-sp-5');
            var parallaxInstance5_1 = new Parallax(scene5_1);
            parallaxInstance5_1.friction(0.075, 0.075);

            var scene6 = document.getElementById('scene_6');
            var parallaxInstance6 = new Parallax(scene6);
            parallaxInstance6.friction(0.075, 0.075);
        },
        initElement: function initElement() {
            this.aMPage = document.getElementsByClassName('m-page');
            this.moveBar(this.aMPage[0], 0, 6000);
        },
        resetHeight: function resetHeight() {
            var dhBannerPc = this.$refs['dh-banner-pc'];
            var aDhSlider = dhBannerPc.getElementsByClassName('dh-slider');
            for (var i = 0; i < aDhSlider.length; i++) {
                aDhSlider[i].style.height = this.bannerPcHeight + 'px';
            }
        },
        paginationHandle: function paginationHandle(e, index) {
            if (this.isMoveing) {
                this.nowIndex = index;
                this.isMoveing = false;
            }
        },
        scrollHandle: function scrollHandle() {
            var _this2 = this;

            window.addEventListener('scroll', function () {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;

                if (nowScrollTop > 0) {
                    _this2.isFixed = true;
                } else {
                    _this2.isFixed = false;
                }
            }, false);
        },
        dsMouseOverHandle: function dsMouseOverHandle() {
            this.isDsRadio = true;
            this.isQrcode = true;
        },
        dsMouseOutHandle: function dsMouseOutHandle() {
            this.isDsRadio = false;
            this.isQrcode = false;
        },
        moveBar: function moveBar(obj, target, time) {
            var _this3 = this;

            obj.raf = null;
            var startTime = Date.now();
            var time = time;
            var curNum = -100;
            var target = target;
            if (obj.raf) cancelAnimationFrame(obj.raf);

            var tween = {
                linear: function linear(t, b, c, d) {
                    return c * t / d + b;
                },
                easeInQuad: function easeInQuad(t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function easeOutQuad(t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function easeInOutQuad(t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                    return -c / 2 * (--t * (t - 2) - 1) + b;
                }
            };

            var run = function run() {
                var changeTime = Date.now() - startTime;
                if (changeTime >= time) {
                    changeTime = time;
                }
                var value = tween.linear(changeTime, curNum, target - curNum, time);

                obj.style[_this3.transform] = 'translate3d(' + value + '%,0,0)';
                if (changeTime == time) {
                    cancelAnimationFrame(obj.raf);
                    if (_this3.nowIndex >= _this3.aMPage.length - 1) {
                        _this3.nowIndex = 0;
                    } else {
                        _this3.nowIndex++;
                    }
                } else {
                    cancelAnimationFrame(obj.raf);
                    obj.raf = requestAnimationFrame(run);
                }
            };
            run();
        },
        downloadMobile: function downloadMobile() {
            var _this4 = this;

            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            if (isIOS) {
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this4.isLoading = false;
                    window.location.href = "https://itunes.apple.com/us/app/%E7%82%B9%E7%82%B9-%E7%82%B9%E4%B8%80%E7%82%B9%E5%B0%B1%E6%9C%89%E9%92%B1/id1259010187?l=zh&ls=1&mt=8";
                }, 1000);
            } else if (isAndroid) {
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return;
                }
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this4.isLoading = false;
                    window.location.href = _this4.nowDownloadUrl;
                }, 1000);
            }
        },
        addClass: function addClass(obj, sClass) {
            if (obj.className) {
                obj.className += ' ' + sClass;
            } else {
                obj.className += sClass;
            }
        },
        removeClass: function removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "");
        },
        setCss3: function setCss3(obj, json) {
            var prefixes = ['Webkit', 'Moz', 'Ms', 'O'];
            for (var sAttr in json) {
                var sAttrUpper = sAttr.charAt(0).toUpperCase() + sAttr.substring(1);
                for (var i = 0; i < prefixes.length; i++) {
                    obj.style[prefixes[i] + sAttrUpper] = json[sAttr];
                }
            }
        }
    }
});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-home"
  }, [(_vm.isPc) ? _c('div', {
    staticClass: "diandian-pc"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "dh-banner-pc",
    staticClass: "dh-banner-pc"
  }, [_c('div', {
    staticClass: "dh-slider-background"
  }, [_c('div', {
    staticClass: "dh-bg-1",
    class: {
      'anima_slider': _vm.isDs_1_bg, 'anima_slider_reverse': _vm.isDs_1_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-2",
    class: {
      'anima_slider': _vm.isDs_2_bg, 'anima_slider_reverse': _vm.isDs_2_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-3",
    class: {
      'anima_slider': _vm.isDs_3_bg, 'anima_slider_reverse': _vm.isDs_3_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-4",
    class: {
      'anima_slider': _vm.isDs_4_bg, 'anima_slider_reverse': _vm.isDs_4_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-5",
    class: {
      'anima_slider': _vm.isDs_5_bg, 'anima_slider_reverse': _vm.isDs_5_bg_rs
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_1_bg),
      expression: "isDs_1_bg"
    }],
    staticClass: "dh-slider dh-slider-1"
  }, [_c('div', {
    staticClass: "ss-main",
    attrs: {
      "id": "scene"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_1, 'bounceOutUp': !_vm.isDs_1
    }
  }, [_c('h1', {}, [_vm._v("点点")]), _vm._v(" "), _c('h2', [_vm._v("一站式生活消费金融神器")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])]), _vm._v(" "), _c('div', {
    staticClass: "slide-phone anim_dh_phone",
    class: {
      'bounceInUp': _vm.isDs_1, 'bounceOutUp2': !_vm.isDs_1
    },
    attrs: {
      "id": "scene-sp-1"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.45"
    }
  }, [_c('img', {
    staticClass: "sp-1",
    class: {
      'anima_round1': _vm.isDs_1, 'anima_round1_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "82",
      "src": __webpack_require__(233)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('img', {
    staticClass: "sp-2",
    class: {
      'anima_round2': _vm.isDs_1, 'anima_round2_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "68",
      "src": __webpack_require__(234)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('img', {
    staticClass: "sp-3",
    class: {
      'anima_round3': _vm.isDs_1, 'anima_round3_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "88",
      "src": __webpack_require__(235)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.125"
    }
  }, [_c('img', {
    staticClass: "sp-4",
    class: {
      'anima_phone': _vm.isDs_1, 'anima_phone_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "258",
      "src": __webpack_require__(236)
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_2_bg),
      expression: "isDs_2_bg"
    }],
    staticClass: "dh-slider dh-slider-2"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_2"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_2, 'bounceOutUp': !_vm.isDs_2
    }
  }, [_c('h1', {}, [_vm._v("借钱还卡")]), _vm._v(" "), _c('h2', [_vm._v("还逾期,一键帮还信用卡")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-card",
    class: {
      'bounceInUp': _vm.isDs_2, 'bounceOutUp2': !_vm.isDs_2
    },
    attrs: {
      "id": "scene-sp-2"
    }
  }, [_c('div', [_c('div', {
    staticClass: "q-dd-1",
    class: {
      'anima_q_dd_2': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "q-dd-2",
    class: {
      'anima_q_dd_1': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.35"
    }
  }, [_c('div', {
    staticClass: "r-c-1",
    class: {
      'zoomIn': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.15"
    }
  }, [_c('div', {
    staticClass: "r-c-2",
    class: {
      'zoomIn': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.25"
    }
  }, [_c('div', {
    staticClass: "hb hb-1",
    class: {
      'anima_hb_1': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "hb hb-2",
    class: {
      'anima_hb_2': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "hb hb-3",
    class: {
      'anima_hb_3': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.5"
    }
  }, [_c('div', {
    staticClass: "hb hb-4",
    class: {
      'anima_hb_4': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.25"
    }
  }, [_c('div', {
    staticClass: "hb hb-5",
    class: {
      'anima_hb_5': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.45"
    }
  }, [_c('div', {
    staticClass: "symbols-card",
    class: {
      'anima_card': _vm.isDs_2
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_3_bg),
      expression: "isDs_3_bg"
    }],
    staticClass: "dh-slider dh-slider-3"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_3"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_3, 'bounceOutUp': !_vm.isDs_3
    }
  }, [_c('h1', {}, [_vm._v("借一点")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "jk-main banner-box",
    class: {
      'bounceInUp': _vm.isDs_3, 'bounceOutUp2': !_vm.isDs_3
    },
    attrs: {
      "id": "scene-sp-3"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.1"
    }
  }, [_c('div', {
    staticClass: "jk jk-round-bg",
    class: {
      'jk_round': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "jk jk-icon",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-1",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-2",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-3",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_4_bg),
      expression: "isDs_4_bg"
    }],
    staticClass: "dh-slider dh-slider-4"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_4"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_4, 'bounceOutUp': !_vm.isDs_4
    }
  }, [_c('h1', {}, [_vm._v("点点闪付")]), _vm._v(" "), _c('h2', [_vm._v("点点闪付,买单超舒服")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "banner-box",
    class: {
      'bounceInUp': _vm.isDs_4, 'bounceOutUp2': !_vm.isDs_4
    },
    attrs: {
      "id": "scene-sp-4"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_5_bg),
      expression: "isDs_5_bg"
    }],
    staticClass: "dh-slider dh-slider-5"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_5"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_5, 'bounceOutUp': !_vm.isDs_5
    }
  }, [_c('h1', {}, [_vm._v("生活所需 一站完成")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "banner-box",
    class: {
      'bounceInUp': _vm.isDs_5, 'bounceOutUp2': !_vm.isDs_5
    },
    attrs: {
      "id": "scene-sp-5"
    }
  }, [_c('div', {
    staticClass: "lw box-bg",
    attrs: {
      "data-depth": "0.1"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "dh-pagination"
  }, _vm._l((_vm.page), function(item, index) {
    return _c('div', {
      staticClass: "dh-page",
      on: {
        "click": function($event) {
          return _vm.paginationHandle($event, index)
        }
      }
    }, [_c('span', {
      staticClass: "m-page"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dh-life"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "dh-sm-download"
  }, [_c('div', {
    staticClass: "dd-sd",
    on: {
      "mouseover": _vm.dsMouseOverHandle,
      "mouseout": _vm.dsMouseOutHandle
    }
  }, [_c('div', {
    staticClass: "dd-sd-radio",
    class: {
      'dsRadio': _vm.isDsRadio
    }
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('p', [_vm._v("下载点点手机客户端，即刻开启品质生活")]), _vm._v(" "), (_vm.isQrcode) ? _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "ra"
  }), _vm._v(" "), _vm._m(11)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hz-phone"
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "box"
    }
  })]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "diandinan-mobile"
  }, [_c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    staticClass: "nav-main"
  }, [_c('div', {
    staticClass: "dd-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-download",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_c('i'), _vm._v("下载点点\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(237),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(238),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(239),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(240),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": __webpack_require__(241),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination my-swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-nav"
  }, [_c('div', {
    staticClass: "nav-main"
  }, [_c('div', {
    staticClass: "dd-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-download"
  }, [_c('i'), _vm._v("下载点点\n                    "), _c('div', {
    staticClass: "nav-qrcode"
  }, [_c('div', {
    staticClass: "qrcode-main"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("额度高至20万,"), _c('br'), _vm._v("一秒审核3秒放款")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "pos pos-hb-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "pos pos-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.5"
    }
  }, [_c('div', {
    staticClass: "pos pos-r-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "pos pos-r-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("话费充值／加油卡／"), _c('br'), _vm._v("水电煤／游戏充值")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "lw box-liwu"
  }, [_c('div', {
    staticClass: "bl-h"
  }), _vm._v(" "), _c('div', {
    staticClass: "scene_6",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "scene_6"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "bl-l"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bl-q"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "pos pos-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("DIANDIAN")]), _vm._v(" "), _c('p', [_vm._v("点点")]), _vm._v(" "), _c('span', [_vm._v("让生活，好一点")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("\n                        扫码下载"), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-container"
  }, [_c('div', {
    staticClass: "qrcode-main"
  }, [_c('div', {
    staticClass: "qrcode"
  })]), _vm._v(" "), _c('span', [_vm._v("扫码下载点点手机客户端")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-about"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', [_vm._v("关于点点")])]), _vm._v(" "), _c('div', {
    staticClass: "about-main"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("智能生活")]), _vm._v(" "), _c('p', [_vm._v("国内领先的智能生活金融服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("综合服务")]), _vm._v(" "), _c('p', [_vm._v("提供最优质的综合生活与金融连接服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("深度合作")]), _vm._v(" "), _c('p', [_vm._v("与国内众多知名金融机构达成深度合作")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-coop"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNER")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("战略合作")])]), _vm._v(" "), _c('div', {
    staticClass: "dh-wa"
  }, [_c('div', {
    staticClass: "dw-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "dw-r"
  })]), _vm._v(" "), _c('p', {
    staticClass: "coop-text"
  }, [_vm._v("众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-partner"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "download-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫下载点点APP")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "wx-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫关注点点官微")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_vm._v("\n                Copyright © 2017 - 2018 Diandian 点点版权所有 粤ICP备17079095号-2\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-life"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("DIANDIAN")]), _vm._v(" "), _c('p', [_vm._v("点点")]), _vm._v(" "), _c('span', [_vm._v("让生活，好一点")])]), _vm._v(" "), _c('div', {
    staticClass: "hz-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-about"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', [_vm._v("关于点点")])]), _vm._v(" "), _c('div', {
    staticClass: "about-main"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("智能生活")]), _vm._v(" "), _c('p', [_vm._v("国内领先的智能生活金融服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("综合服务")]), _vm._v(" "), _c('p', [_vm._v("提供最优质的综合生活与金融连接服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("深度合作")]), _vm._v(" "), _c('p', [_vm._v("与国内众多知名金融机构达成深度合作")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-coop"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNER")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("战略合作")])]), _vm._v(" "), _c('div', {
    staticClass: "dh-wa"
  }, [_c('div', {
    staticClass: "dw-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "dw-r"
  })]), _vm._v(" "), _c('p', {
    staticClass: "coop-text"
  }, [_vm._v("众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-partner"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "download-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫下载点点APP")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "wx-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫关注点点官微")])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_c('p', [_vm._v("Copyright © 2017 - 2018 Diandian")]), _vm._v(" "), _c('p', [_vm._v("点点版权所有 粤ICP备17079095号-2")])])])
}]}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACmCAMAAABjo9R4AAADAFBMVEUAAAASws8m1NcqwNgxzNlDu+BEut80uNoU68tBut9Ku+AX3s02tN1AuuA3s90U7Msc4tBKu+BLuuA3s91KvOBKu+Ab4c9Ku+Ad4s9FvuAW3stKvOBGvN9FvN9Fu+IU7MtCut9EuuBKveBIwd9Jv+BGvOAb389JwOAc4M9Lu+EY5c4c4s9Gud9Ext0X584X5swV6stMvOE2tN0f2tEl09Qa4s4V6cwW6sxKvuEX5cwg2dE3s91Lu+EW6sxLvOFJvuA3s942s90Y5swzu9sb388W6cw1td0d4NAtw9gW6swxythKvOI2tN02td0b4s8+z9o3tN1Jv+AW6cwV6sw1t90V68w9xNsc3s8i1NIlz9Qk0dMf2tIV6ssg2tIe2dAuytgoy9cszNYqytYwvttLu+A3s91KvOAb4M8nzNUf29Ag19If2dEl0NRIwd8i1dIU68sk0dMa4c4W6Ms1tt0d3NAzutsxvdpGxN4qx9cpydYj09JBzNsZ5M1Iv+BKvuAX5cw0uNxDyNwX580vwNkj1NMc3dAX5c1Hwt8oytZExt5Cytwwv9oZ484c3tAyu9s4tN0/z9osxddFxd4Z4s0V6cwtw9glz9MuwtknztUh2NI1uNxAztvV7/gtxNjP7fdRvuFXwOKH0+qf2+91zOix4vM+t9/P8PdFueBEyN3H7/VJuuA+0No80dkx0Ncsz9bM8PY3v9s5z9nJ6/bD6vU10NhBuOA7td7T8vfP8vfM9fa57vEsx9iy7PDS7/et6PAyxtjH9PTB8vO/7fO35vM4udyQ3+tcxONOveFAwN286PRIyt6Y4u1OyOAvzNhPzd85w9sk0tTX8/jR9var4fGh5O6m5u5lxuVAvN0+yduI2+puyudq0eRby+Isydhy0+ZVz+BMw+CX2u561ed04+NIzt2O1ex+z+mB2+g0ytkv1dWe6uxlzORf399Z19+l3vCL4+h42uZg0OJUxuFS1d5O3dxL09w6yNqo6+6V6Opo2eJE1NqB5eZo4eEv2tQ82diL6edeFroOAAAAZHRSTlMAAwgGDh4TDOoX9hbtSfXzNeL9/PHtHedAOBH5VUAl+mxip56MKyJ1K8hxTjDte/Pg1tHLje/ZlID76uTb0r2WlolX893Av1/syMSzsHdm8NzPtqyjiFv59vHhsKGg9qp81+/b+AQpXgAAFIdJREFUeNrM18uKo0AUBuD2UlVU0Qa0FREvqFFEcGNWQsQkm2yShgRCP4F5njxF09D76eebk5lFzTBJTKKVnv8JPn7rnLKehowsqxhBsCpJT/9TFIUQjCmlgAuCtHB8xynSAB1DKcYqkeVvFktyUHhRVo3jpilLnacuyzxfxUkSRr6DydP3RJKIiikKfC2rZnGT17rJ2j/iMsveHplV5BUpoliVlacHR8LIi2ZxXuq2ZZkmY65rtH/HMFzGTMuybb1u4ip00kcqJUIoKvysWuUWa6+Iwcp8nHhaACOlPOaAyliLxqtatyzGjPa6uFCpredNFaZIuFJSVBwUYdVsWXtzDLseJ5pDsdjTKdEgrPLSthgY71C60Gcdz7RCmBJapIWfxLbZ9gnLV5GHKBHilHCQJVvdMo22XxizNuu5kDYJLvxZbLlt73x+/HifLCMN4YEnXcFvWV7zFvsiR6PnzW6RUmlAIkFpNrP5sPRGHvb70XKnDXhhKqkfNza0OCQSlKPN5NUjw5RJqBblNRzGgZHAnM5fAzrEyVTfstJmYBwaCXl5nq7nAe6plI6LZ2bBlxaChDInaz8lci+jGiSxDqdRGBJO5mTZa2cqcuDHOQy1QCR88k2oUXJ3j8hZbU3WDo58PyK58mV6nPI7e1Qdb2sbrQjkbx4vc/6KVOmu7ag1NRve2H5wJFdOFyG+79e25iMjFAkZrRe3ryLZ8XLdFWFsYW6+/kH+Wuw3KmXsZTpf4AMP9xcgT3Q5T29SKnxkhg9HnujyBiP2Qpv3KLxJ3mWgStfPda4L6hGQsMoP+9NKmHH12me1H/Hz+EAkKHcLRK68Z5pSoPE8EgJXpHeNUim0kv/2CEC+n0eCchFSpduIxg0TYeSX4qmx4XfPpPufSMJFx8cWigTlNNS6nhRqmNgijYD8OuwvKifLjqUuoyQ2W4EB5KED+TzxA+WS0X+rxRrhvgFjh3K3wJdeC15mtULz2Y08vsgROW9MG3i6ig1/OlxQTiNNPodEvqgNyZu8iOTbMjp3ieNqLNz4CQuoOy+bZXpaqaDZirViw7dk54T/pM18XpsGwzgep3UM2oM6GYIWqxMR9KAnQUGlsIsKCv4Hzt52KsNTSm+9LfcR3qS/LO7iSGg85dSYtMdSSLEOSQeth0IP/Qt88vaNMSxd32fod0v6JmnWz57n/fF90sS5eO/zFMH4P2bJaGl2IXb6yWz8UyD8LBmteeKeC67Bmv3PofCzZJjwaycTvpJ4+RYx/fzPsc3WcDAaJ6tDtNHFi45tTiVPVjyrqZu4HqmcQc5lBCRUPJFeie+RjjKo4mWrNNv8vTJKeT7xEuMiHdUel/EauAhImNFTd85H50hUj1TGI42gpbWmBwCJ6ZUXohZtA5NsdVQxuzJaek1BhJLOldFVG2MjVbdDunKrhpNGZG3s1j9geuWd1RByDbVqO/ZAk2UyraA07egyGY2bHxChfPPX0FlJ38PYHz/ZcqvnqijZ1ZEGCXfqmF4JVXhYIT7EBFKt1GS5N1S3UXLcqm6SjtowEJAvMgHkSiqzgUq2bspa1XWQTrKhTFumNqoiEg6FxFqw2qAqG8cda7KpD2wH6yQPhj1CKuUG9wCX4FuewGVcRA0btdKjyXawD6Elwx9wWksFSv6hc5/V4GuY72ocu9eRSWWk4KtEw4Gpy9RdBXoltxdiDn0l/XD9MqL7w/SDT/aB/zDfYAlvYsZ3anU+thF1rFItky7puOqZaptmuUJIb3iAMGyvM6tzJ4kY2yok26yM1LM5ckNx/WnIdQzE0njRh8Q4ScVtaf66oZzNkUsNFe7XBjY/5NbztflztKvbOaptENuDaJuJHUGygZEmO/r+4J7wbHhunmxJkijlPOENv01PwcbEWsERiI6crQQzF9yQ4yGBpc12sJCGwRDqsDiarem2IUUg8wshk49geNMJKMcnx67pXT/ZOYQAsgmBZEhGQ+1o/lJgUIwQKcCKvvqhvJYASKgSORlVVwe7Va4iIaFHhnGrOzUdLNugzrDzEUg4irzCy5MbaUFIvF3P8SlINjBi1GhYeclPKQg+ujkeEUh4Li/lmeBsuJ1QMpMSzqcfcma7oI6mYNGmag4J2bRouBhOfTDWTOrRF0NK7McX2DUhce0SJyP146Q8wAaybkQiY9WVmm76CQ+ATlfyxWshfYMTkvpxatGQkJaVjyoHlg2GX3//dDqJQT5/Idy4vuGHqZBje9jixZJtRxnpXXF7JrFft/ZBf4Cg5SecFmX+2eBauA9eWSv77p2QyvBBOjbz4zkkJDCGIHSzfNtMOrYIl6KQRXoQvpNCvnonZO5eLRQKolhYosCPe/GX4/+G2AfGInx0kYm2963C3KP3gYmdCzYqH/zPPru1xQvpBX48BgpacZAiqA8cUUh63J9btr7FAQlfPgl3N9dFDs2YHy+IGPUtCGSMrLlHn4lwdZn23zwSHm+u78RKhN+gJXo2tWjl2Q634C6a7FhIz+6QT/rEs5ZDXnn/Rth8RiO5Q3/jBYyTYz/ZP2wWyOgd9P+JubsNcdz9W8Vi0LJElvDdpSomk8LmbYjkMnk/wY+b+mQmIiLZhmTvxkKC+t8r5FNvyAOZTQrPGGSptLNYs2Hva1dvHXn8jKU2IC5W//gbkb+0PKDc29uNF7uSzQrPbnFBTs2vWmti81O2T4U8LJWHX2Stxgl5+9aD0lJ5Rz86n2WzVznyohc+LrqjfXi4t1iHk2OdmJ9//YQ3ceg3p2YM4jQUxvFzcHBwFQQFxeGm2xzcHAQpB3II4qri7GorN5UOYm6xB6WDdg3NFLVDQlsTzBFok5BSbKChNdEQ6EE5bCtWzsn/e0n6Woua+id57/v++Uh+/ZK8Qu/SQT6xph/bktT+OJ6tUmaz9PA6418h37QCV3wttL1hesjsP4Vejj1NfM07X2bZ52tHLWvVIIhPYwE2CRfW0MN9eed6LVSl0dZNQKbRbKxoknTkjGfPf0ecDYfW5zXIGPGz1Wr9xtjy3HfvxbY3RlEqYQnaOSTKQmRkERPNrUFQ4yWxp89YDRkt16y1g/FnElNFiAcHtGeDoyPX66wwwhMkUQ8OVxhRT7Xu4MVJDZnFyWtdSekNrewKpN7jRTew1iHRs8FIEPSAQVIvEN6LWjBAUVrIGzd3XhAdLinKl10aWTi9JImma1E/rrFGJt8V24NhdoF4EOnNbEx6NvI6SBLPGh/VJN50D1GVSk8zGXx3p4PEbpAbhV6aQ1AyyMAFujAaWLSwFRMVCoXO1BPe87Vg3CkgpdsBvBrP11yAI8OGOloeKSmE4rlAILcBmVaG5Y0IkD6ymFm1hqZCvo8GfjXf6cRnx5gd4lXje/qLN0hjciP2quBOKA7i+j+o8Pjx1vaN9JCHxtRri125p/tWldl4dUSJdMwAZCFRZzjQRF7QJ7CY51EvgJdagLy6vZMnqi6UpyIzy2KnatgTV+zyghsYS741dY4kSVP8Kjt13nbqPO/oBnjKVIXyC19pM4/uEB0Q0yyOl+fd3a37G0BiMAYTDZSmaxtV5tu6g9WpPrUX1+zY07rAC+aoEyOCseMP2vD0xIMSOJat6dbu7a3L9wG5gdBLnfRy5BlL/PaUPGuKWVXLpTK2udFr8nyzZ/eRQcTrk96ixpiXIXh0jHeIxcyBMg/ubV289Dskx/0tor3k0cuRbeQ5RmkqIo8bnqeQquE3NR4Lf5+CQOWKGvfWnZdQs0qSQLJ4FfLsxR1uI6GXIxOU2mRgxFa/P58bvhJhqaWSyulOhKyWKlAJ4zxMeltBlghHWMRmjIs9c/3h1jlA5jfDNLAQYf3WJ3ZECURVVTlTiSBUld5YUTE5dXFJ1Zg2kw+xIeTDO/jfr7t7HLdPReYkWvNYxoX+V1PuitpkGnJ9iojzquG0SW9nv+/2BP5D0zfUYqwK+QgiX3d8Ti1WKnDIuKZKscLipCBz5RL56W9nM0gonHwVQOlOKKRKYRrz0KnLeDFsu6fIcrMXqo1iLJWjD4Oj76sMI6Uy98/jR9QHu3v7myr0dUfuCvVT/1htEOVyucaxf6qJsthsirKA5eiYmMQvqvt4RmU8o/sqvGIxsrHho5GACcfYHClz+Swgr/0H5KtwpAuyJExO5+hXLqZ59U3RYAqSXP9h9xcXb5BnVJYVMwQ3AyARi+PSBpvjmkcXz+GH/e1re68i4eJMzMO+6pA8/GY6skS6szjfs8bxySkoJVE7PTleYvzaE+QPzRMwPsttqGJm98IZ+ieSvZcMYQ0yGaDlsrc/SS+B843gPIv0KTxR6oJQV07CT7GXa7zF4kOe0e9vG4lHZsrLMpazGtrIX6SaTUvjQBjHXeuuh156WsTD3lZkPdqTX0DoQW/SRsSXU5FSelw99+CxJynsJ1iaBAI5mCKS7HUJFMFjT1nYprRESENft+4/k6RPY6jU9kcnk3lmOv58ZiYKbeqj9yWRw9IMYOXXgKKS1NDr9cafXvcOC+uU6pjUm19vOHa/bzs6Qj6NYe8n9mjb0TGEvSJQOMLFafKT97HdRLKCl1uCVghSlGQdkt8bf9mP708r1aWSbZckajcGvx+Uu+qTU8Gg+SHJM0hivb+ew3IOKhJoNHTmdHNzcyU5TQhgIWU0fa7q6K9PWvKzxX4RW5/Estmb+bk4O1pfAbEvqUNkrfIGJZ73MogcAigy6pLVVBUciYGOSBQ4/rDw8Kl27VKd+b1fct//CnIcDyGJ5yu8i6uEwuPKAlBjcrKgg2wYkXea94py3xzIaEURni1NUbR+WxCzC3F1nojjcIPN5OmhBPgoEkMGAimGLL1c2gOyIISK1VQekWn0LkbmfHtthbG+c3AhCgx5GsFDBFkikstu9U7p9ngh6tgfasqdZrTlhR1Tp0gkYzVxxIkuAkF+oFzOvmHZ6yruruPF8KiywA97LI/Ooo7lzHEyvuKztn2eKYfJ4RUO5IJCV4Y4sB80RX2yeJHiuAot45f6qBotWSz7saCXCEbTrBQHONtrgWRsK8Xd0sB58acTBt7hcXgxR4i8YcGx2rKno6RDjdd9VN9y+xvsbAdHJ5O7JWCM4uO1X7cohly275HLpiWX3SgrYntUheNwJIcc/V4GzReuqQfHZvMDSZ4lF5YE5iB4EAXvFOXR0M3jqA3HhSW51BYSGRDb3uEKRK0WupvJLXDrnNhpVVVF7Q0F9h60WR4tQzZrNYyJQHPncoVZZE7ONleID1sbXPrdkkRu3OlWFTyIBmahAEezZbh5NFomzbCAZPIAx4aIfT7ZdS2vGahZCa4UnWZ6dM1kudReDPO6UOu07rVH9cUYm5F5ZsxWAK96C2kugX8lp4knj5eQhJiby0el+TI2a8gjHDVjBMclJPd2t9fCkqsb+3vFYjGfpwJQUyRcvOv19WSs2Rm5f6eHRqeDPGJ/js3Xo4OazTohes+u6ZNkfOJIRye9hCQYe3IvLV8WjstIZpLf2LGJ7Mo8cQm8mpU5KP5jy6xqmrfs+Uuah+7mJc1tbMVIj3blUpKwZAcGuAcIjktJ7u0maLVpVyZ2uOLlUuSRSxWO3d7/4s7ftW0giuO1bIhAgzUJocWbEBJIglQSMmgRFkaLBwnhQh3TzTQdikPHQqDQTMnULP77unXuWLf9ni7Hsyuc+kdsf/Ddvbv37vLlnaQzGeTfy8VhS725ekcaiZamX/avF9eLGjTX/7ZwMr/4UI8ixUMdGsnLC61Ms2mUj9CMPn9GNmgrr6+m1zV8BeID9Z8D6y9/ff/xg/JIa62vKTTWSzf5IDa7SWf0uo+AXVismQvw89cf5HGnyU2ml2/5qd2kpaiX/feAR6JlpYGIWK1pxmK5XDbnU1TDR37q9W1HbHYDyXx7Od1NpIgGJHs3kbD+8U8HqYpEbuBCH/Ux4cxM377WSCNB5w42/MyM+1c4a55BUuxo+on4+lVYBPkaXpqzP+MB3dkb6Azd/vT9GUW+pzt7I60Obp7xA+NrDbWwRI3SjFiNa46ST1gUt2IjkRtvmvUzPBifTSQ2Wzdb/xXZNvXLwXjGeHiC2zMOWmHSOIKot6l9QANDzGiuhV7fTo32Fq89MSxs+KqI0/EQDFJd2u7du6ozCGbnIKhsBRq3UqmpBTb89AQD27nY/sV0+nDgzeaMGW/IPhqz4MrVSOM2N082GM9PCvLoDjuvdqBt6MMk+Abu71GB+ZwV6jPIfw94FFpeY2wOmEUr8FGKFRZ8LI+kcdtcFokXz08mkvK4i8qO6uR+fP+55p633K5Z7W2OQUUW1TVrc4LI3imPdI+XuQeVJxAZB4mddvZ7j7WlZ2GMNe7ubm/RoOUFPQHs2g9YTTZv63jAx+v5hPB89nx3qEDjXioVa5IFHtZlf4Atx2iKvH1GJLO4xqZIwBaIvTCnc2Z3lW1NjUoPizO4DG6tszYiogCJpzGKevLGYZbqxn4a6UtwGMRHFOkF2YT+xbcfLUMbur53e/vlCW5R/+6O6toDyEtzyF6L8IpI1Q5/dbikD7PQi7/c3LAPivgANEDUtcFt3gWiT59aKLfjWA4jF18pDkcyVKfMY66II+QSokd90OzzIkbk0E0147CtpiemFZW+HCMtLwaW8uSkoLv6cJVtxRy5iXyzxiOgGqUeFD5WhB7YzEGg15MnlWp1XkYjXZlFLnvxBpFUmiIplkY8z08qOghfTGXHtNzIl28+Mh5rWEsWSi1lZRRAWt1SDLLYLSaOqhhH+MUSSUntLJHlXu9mf5Hodz0f97SFZ+MxaHUMU7WrxO993JvHrlxGjqoZR/yRCslIR0Xuy90uMvYEjO3ANstymFd2I4svn03NdEaTQu5i73ajm2SVrVoKZfGISKpeRXkiI5+97Xa+10UO/bCcjBycL6dBkgzFtNJRVG53fcpyVrq2rmpK5+LISWwelm5VZKEvI6Wgx1i5/kAXwOsn+SQaOqYCgadGujAURbPUdORWkzLLw5CpFbvrQ1pRRpU90nVTU1gOofE8tAxFd2w3mhRZQiLrKzDPyknlpo5lHqruL7QMPOFof8S/AAAAAElFTkSuQmCC"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/symbols-reflections.587aa27.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner-phone1.e4e3cb5.jpg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner-phone2.a32f33b.jpg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner-phone3.822f593.jpg";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner-phone4.ac58b34.jpg";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner-phone5.912e2a7.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isVersioning: false
        };
    },
    created: function created() {},
    mounted: function mounted() {
        if (localStorage.getItem('appApplySwitch') == '1') {
            this.isVersioning = true;
        } else {
            this.isVersioning = false;
        }
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        document.title = '关于点点';
        next();
    }
});

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "about-detail"
  }, [_c('div', {
    staticClass: "ad-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "ad-box mt-f ab-1"
  }, [_c('div', {
    staticClass: "ad-title"
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('p', {
    staticClass: "ad-mt"
  }, [_c('b', [_vm._v("·点点")]), _vm._v("，国内领先的智能生活金融服务平台，旨为中国消费者提供最优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-box ab-2 mt-25"
  }, [_c('div', {
    staticClass: "ad-title"
  }, [_vm._v("了解点点")]), _vm._v(" "), _c('ul', {
    staticClass: "ad-info"
  }, [_c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("方便一点")]), _vm._v(" "), _c('p', [_vm._v("额度高至20万,日费率低至0.02%,快至一秒审核三秒放款,为应急解忧")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("安全一点")]), _vm._v(" "), _c('p', [_vm._v("众安深度战略合作,拒绝高利贷,保障账户安全")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("品质一点")]), _vm._v(" "), _c('p', [_vm._v("精选稀缺商品、分期免息买好物,助力品质生活")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("实惠一点")]), _vm._v(" "), _c('p', [_vm._v("各类优惠券、免息券拿到手软,积分兑换、促销活动天天办")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("丰富一点")]), _vm._v(" "), _c('p', [_vm._v("可还信用卡、可线下消费,想你所想一站式服务")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("便利一点")]), _vm._v(" "), _c('p', [_vm._v("充值缴费、看电影……足不出户便利生活")])])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center",
      "font-size": "12px",
      "color": "grey"
    }
  }, [_vm._v("copyright ©保山施甸长江村镇银行股份有限公司")])])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  "data-v-5d699f30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
        FiHeader: __WEBPACK_IMPORTED_MODULE_3__components_header___default.a,
        FiFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            nowIndex: 0,
            page: 6,
            isMoveing: true,
            navText: ['借点', '点点商城', '点点闪付', '生活缴费', '充值娱乐', '办信用卡'],
            navActive: [true],
            isQrCode: [false, false, false],
            tapTimer: null,
            isDianDianHome: false,
            isBepoint: false,
            isJgWin: true,
            swiperOption: {
                speed: 450,
                height: 420,

                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {},
                    transitionEnd: function transitionEnd() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start();
                        }
                    }
                }
            }
        };
    },

    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    watch: {
        nowIndex: function nowIndex(n, o) {
            cancelAnimationFrame(this.aMPage[o].raf);

            this.navActive = [];
            this.navActive[n] = true;
            this.aMPage[o].style[this.transform] = 'translate3d(-100%,0,0)';
            this.moveBar(this.aMPage[n], 0, 6000);
            this.bannerMoveHandle(n, o);
        }
    },
    created: function created() {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isIos || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isAndroid) {
            this.isMobile = true;
        } else {
            this.isPc = true;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        if (window.location.host == 'www.bepoint.cn') {
            document.title = '深圳蜂点科技有限公司';
            this.isBepoint = true;
        } else {
            document.title = '点点_点点app_点点官网_国内领先的智能生活金融服务平台';
            this.isDianDianHome = true;
            this.$nextTick(function () {
                _this2.bannerLeft = document.getElementsByClassName('banner-left')[0];
                _this2.leftLi = _this2.bannerLeft.getElementsByTagName('li');
                _this2.bannerRight = document.getElementsByClassName('banner-right')[0];
                _this2.rightLi = _this2.bannerRight.getElementsByTagName('li');

                _this2.pfx();
                _this2.initElement();
            });
        }
    },

    methods: {
        pfx: function pfx() {
            var prefix = function () {
                var tempDom = document.createElement('div').style,
                    prefixStrArr = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                    sPre;
                for (var i = 0; i < prefixStrArr.length; i++) {
                    if (prefixStrArr[i] + 'ransform' in tempDom) {
                        sPre = prefixStrArr[i].substring(0, prefixStrArr[i].length - 1);
                        window.cssPrefix = sPre ? sPre : '';
                        window.css_Prefix = sPre ? '-' + sPre.toLowerCase() + '-' : '';
                    }
                }
                tempDom = null;
                return function (style) {
                    if (sPre === '') return style;
                    style = style.charAt(0).toUpperCase() + style.substring(1);
                    return sPre + style;
                };
            }();
            var _vTransitionEnd = {
                '': 'transitionend',
                'webkit': 'webkitTransitionEnd',
                'Moz': 'transitionend',
                'O': 'otransitionend',
                'ms': 'MSTransitionEnd'
            };
            this.transform = prefix('transform');
            this.transition = prefix('transition');
            this.transitionEnd = _vTransitionEnd[window.cssPrefix];
            var transitionDelay = prefix('transitionDelay'),
                transitionDuration = prefix('transitionDuration'),
                transitionProperty = prefix('transitionProperty'),
                transitionTimingFunction = prefix('transitionTimingFunction');
        },
        initElement: function initElement() {
            this.aMPage = document.getElementsByClassName('m-page');
            this.moveBar(this.aMPage[0], 0, 6000);
        },
        moveFn: function moveFn() {
            this.isMoveing = true;
        },
        versionOverHandle: function versionOverHandle(index) {
            this.isQrCode = [false, false, false];
            this.isQrCode[index] = true;
        },
        versionOutHandle: function versionOutHandle() {
            this.isQrCode = [];
        },
        bannerMoveHandle: function bannerMoveHandle(n, o) {
            var _this3 = this;

            for (var i = 0; i < this.leftLi.length; i++) {
                this.leftLi[i].className = '';
            }
            this.leftLi[o].style[this.transform] = 'translate3d(0,0,0)';
            this.leftLi[o].style['opacity'] = '1';
            this.leftLi[n].style[this.transform] = 'translate3d(0,288px,0)';
            this.leftLi[n].style['opacity'] = '0';

            for (var i = 0; i < this.rightLi.length; i++) {
                this.rightLi[i].className = '';
            }
            this.rightLi[o].style[this.transform] = 'translate3d(0,0,0)';
            this.rightLi[o].style['opacity'] = '1';
            this.rightLi[n].style[this.transform] = 'translate3d(680px,0,0)';
            this.rightLi[n].style['opacity'] = '0';

            clearTimeout(this.tapTimer);
            this.tapTimer = setTimeout(function () {
                _this3.addClass(_this3.leftLi[o], 'transition-y-start');
                _this3.addClass(_this3.leftLi[n], 'transition-y-start');
                _this3.addClass(_this3.rightLi[o], 'transition-x-start');
                _this3.addClass(_this3.rightLi[n], 'transition-x-start');

                _this3.leftLi[o].style[_this3.transform] = 'translate3d(0,-288px,0)';
                _this3.leftLi[o].style['opacity'] = '0';
                _this3.leftLi[n].style[_this3.transform] = 'translate3d(0,0,0)';
                _this3.leftLi[n].style['opacity'] = '1';

                _this3.rightLi[o].style[_this3.transform] = 'translate3d(-680px,0,0)';
                _this3.rightLi[o].style['opacity'] = '0';
                _this3.rightLi[n].style[_this3.transform] = 'translate3d(0px,0,0)';
                _this3.rightLi[n].style['opacity'] = '1';

                var _this = _this3;
                _this3.leftLi[n].removeEventListener(_this.transitionEnd, _this.moveFn, false);
                _this3.leftLi[n].addEventListener(_this.transitionEnd, _this.moveFn, false);
            }, 30);
        },
        paginationHandle: function paginationHandle(index) {
            if (this.isMoveing) {
                this.nowIndex = index;
                this.navActive = [];
                this.navActive[index] = true;
                this.isMoveing = false;
            }
        },
        scrollHandle: function scrollHandle() {
            var _this4 = this;

            window.addEventListener('scroll', function () {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;

                if (nowScrollTop > 0) {
                    _this4.isFixed = true;
                } else {
                    _this4.isFixed = false;
                }
            }, false);
        },
        moveBar: function moveBar(obj, target, time) {
            var _this5 = this;

            if (obj.raf) cancelAnimationFrame(obj.raf);

            var startTime = Date.now();
            var time = time;
            var curNum = -100;
            var target = target;

            var tween = {
                linear: function linear(t, b, c, d) {
                    return c * t / d + b;
                },
                easeInQuad: function easeInQuad(t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function easeOutQuad(t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function easeInOutQuad(t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                    return -c / 2 * (--t * (t - 2) - 1) + b;
                }
            };

            var run = function run() {
                var changeTime = Date.now() - startTime;
                if (changeTime >= time) {
                    changeTime = time;
                }
                var value = tween.linear(changeTime, curNum, target - curNum, time);

                obj.style[_this5.transform] = 'translate3d(' + value + '%,0,0)';
                if (changeTime == time) {
                    if (_this5.nowIndex >= _this5.aMPage.length - 1) {
                        _this5.nowIndex = 0;
                    } else {
                        _this5.nowIndex++;
                    }
                    cancelAnimationFrame(obj.raf);
                } else {
                    cancelAnimationFrame(obj.raf);
                    obj.raf = requestAnimationFrame(run);
                }
            };
            run();
        },
        downloadMobile: function downloadMobile() {
            var _this6 = this;

            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            if (isIOS) {
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this6.isLoading = false;
                    window.location.href = "https://apps.apple.com/cn/app/%E6%8D%A1%E5%AF%8C%E5%AE%9D/id1466062624?from=singlemessage&isappinstalled=0";
                }, 1000);
            } else if (isAndroid) {
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return;
                }
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this6.isLoading = false;
                    window.location.href = _this6.diandianAndroidDownLoadUrl;
                }, 1000);
            }
        },
        addClass: function addClass(obj, sClass) {
            if (obj.className.indexOf(sClass) == -1) {
                if (obj.className) {
                    obj.className += ' ' + sClass;
                } else {
                    obj.className += sClass;
                }
            }
        },
        removeClass: function removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "");
        }
    }
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regbox_index_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regbox_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__regbox_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        RegBox: __WEBPACK_IMPORTED_MODULE_0__regbox_index_vue___default.a
    },
    data: function data() {
        return {
            regBox: {
                show: false,
                status: '',
                isUserShow: false,
                phone: ''
            },
            userPhone: '',
            headerText: [{
                name: '首页',
                route: 'flatindex'
            }, {
                name: '关于我们',
                route: 'aboutus'
            }, {
                name: '商务合作',
                route: 'cooperate'
            }, {
                name: '帮助中心',
                route: 'helpcenter'
            }],
            headerActive: [true]
        };
    },
    mounted: function mounted() {
        var routeName = [];
        this.headerText.forEach(function (e) {
            routeName.push(e.route);
        });
        var index = routeName.indexOf(this.$route.path.replace('/', ''));
        this.headerActive = [];
        this.headerActive[index] = true;

        if (this.$storage.getItem('user').accessKey) {
            this.regBox.phone = this.$storage.getItem('user').phone;
            this.regBox.isUserShow = true;
        } else {
            this.regBox.isUserShow = false;
        }
    },

    methods: {
        headerHandle: function headerHandle(index) {
            this.headerActive = [];
            this.headerActive[index] = true;
            this.$router.push(this.headerText[index].route);
        },
        loginHandle: function loginHandle() {
            this.regBox.show = true;
            this.regBox.status = 0;
        },
        regHandle: function regHandle() {
            this.regBox.show = true;
            this.regBox.status = 1;
        },
        changeUserHandle: function changeUserHandle() {
            this.regBox.show = true;
            this.regBox.status = 0;
        },
        logout: function logout() {
            this.$storage.init();
            this.regBox.isUserShow = false;
        }
    }
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_rsa__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_axios__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_md5__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_md5__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            phone: '',
            code: '',
            password: '',
            codeMsg: '获取验证码',
            isRegister: 0,
            hList: [true, false],
            isLogin: false,
            regBoxData: {
                isCode: true,
                regSuccess: false,
                btnText: '',
                infoText: '',
                isPassword: true
            },
            reg: {
                name: /^([\u4e00-\u9fa5 ]{0,20})$/,
                number: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                card: /^\d{4,19}$/,
                phone: /^1\d{10}$/,
                code: /^\d{4,6}$/,
                pwd: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
            },
            ds: 60
        };
    },

    filters: {
        cpText: function cpText(s) {
            var cpName = '';
            switch (s) {
                case '找回密码':
                    cpName = '提交';
                    break;
            }
            return cpName == '' ? s : cpName;
        }
    },
    props: {
        regBox: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    watch: {
        regBox: {
            handler: function handler(n, o) {
                switch (n.status) {
                    case 0:
                        this.isLogin = true;
                        this.regBoxData.isCode = false;
                        this.regBoxData.btnText = '登录';
                        this.regBoxData.ciText = '注册';
                        this.regBoxData.infoText = '没有账号';
                        this.passwordLoginHandle();
                        break;
                    case 1:
                        this.isLogin = false;
                        this.regBoxData.isCode = true;
                        this.regBoxData.btnText = '注册';
                        this.regBoxData.ciText = '登录';
                        this.regBoxData.infoText = '已有账号';
                        break;
                    case 2:
                        this.password = '';
                        this.isLogin = false;
                        this.regBoxData.btnText = '找回密码';
                        this.regBoxData.isCode = true;
                        break;
                }
            },
            deep: true
        }
    },
    mounted: function mounted() {},

    methods: {
        forgetPwdHandle: function forgetPwdHandle() {
            this.regBox.status = 2;
        },
        regBoxCloseHandle: function regBoxCloseHandle() {
            this.regBox.show = false;
            this.phone = '';
            this.password = '';
            this.code = '';
            this.regBoxData.regSuccess = false;
        },
        passwordLoginHandle: function passwordLoginHandle() {
            this.hList = [];
            this.hList[0] = true;
            this.regBoxData.isPassword = true;
            this.regBoxData.isCode = false;
            this.code = '';
            this.password = '';
        },
        codeLoginHandle: function codeLoginHandle() {
            this.hList = [];
            this.hList[1] = true;
            this.regBoxData.isPassword = false;
            this.regBoxData.isCode = true;
            this.code = '';
            this.password = '';
        },
        regHandle: function regHandle() {
            console.log(this.regBox.status, 'this.regBox.status');
            if (this.regBox.status == 0) {
                this.regBox.status = 1;
                this.regBoxData.isPassword = true;
            } else {
                this.regBox.status = 0;
            }
        },
        getCode: function getCode() {
            var _this = this;

            if (this.codeMsg == '获取验证码') {
                if (this.reg.phone.test(this.phone)) {

                    this.$loading();

                    this.$durex.ddId().then(function (ddId) {
                        window.ddId = ddId;

                        _this.ds = 60;
                        var timer = null;
                        _this.codeMsg = --_this.ds + 's';
                        timer = setInterval(function () {
                            _this.codeMsg = --_this.ds + 's';
                            if (_this.ds == 0) {
                                _this.ds = 60;
                                clearInterval(timer);
                                _this.codeMsg = '获取验证码';
                            }
                        }, 1000);

                        _this.sendOTPForH5V2();
                    }).catch(function (err) {
                        _this.$toast({ 'msg': err });
                    });
                } else {
                    this.$toast({ msg: '请输入正确的手机号' });
                }
            }
        },
        sendOTPForH5V2: function sendOTPForH5V2(v) {
            var _this2 = this;

            var seqNo = Object(__WEBPACK_IMPORTED_MODULE_3__utils_tool__["d" /* randomString */])(20);
            var otpType = '';
            switch (this.regBox.status) {
                case 0:
                    otpType = 0;
                    break;
                case 1:
                    otpType = 1;
                    break;
                case 2:
                    otpType = 2;
                    break;
            }
            var nowParam = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                "ddId": window.ddId,
                "mobile": Object(__WEBPACK_IMPORTED_MODULE_1__utils_rsa__["a" /* default */])(this.phone),
                "otpType": otpType,
                seqNo: seqNo
            }, v);

            __WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].axios({
                id: 'userAPI.sendOTPForH5V2',
                param: nowParam
            }).then(function (res) {
                var data = res.data;
                _this2.$loading.end();
                if (data.code == '9003') {
                    _this2.$durex.show({
                        seqNo: seqNo,
                        scenarioId: 'diandian_smsverifly'
                    }, function (val) {
                        _this2.ds = 60;
                        _this2.sendOTPForH5V2(val);
                    });

                    return;
                }

                if (data.status == "SUCCESS") {
                    _this2.isRegister = data.data.isRegister;
                } else {
                    _this2.$toast({ msg: data.message });
                }
            }).catch(function (err) {
                _this2.$toast({ msg: '请求失败' });
                _this2.$loading.end();
            });
        },
        druxeBoxWidth: function druxeBoxWidth() {},
        applyHandle: function applyHandle() {
            var _this3 = this;

            if (!this.reg.phone.test(this.phone)) {
                this.$toast({ msg: '请输入正确的手机号' });
                return;
            }
            if (this.regBoxData.isCode && !this.reg.code.test(this.code)) {
                this.$toast({ msg: '请输入正确的验证码' });
                return;
            }

            if (this.regBox.status == 1) {
                if (this.regBoxData.isPassword && !this.reg.pwd.test(this.password)) {
                    this.$toast({ msg: '密码必须包含数字和英文' });
                    return;
                }
            } else {
                if (this.regBoxData.isPassword && !this.password) {
                    this.$toast({ msg: '请输入密码' });
                    return;
                }
            }

            var urlParam = this.$route.query;

            this.$loading();
            switch (this.regBox.status) {
                case 0:
                    if (this.hList[0]) {
                        this.$durex.ddId().then(function (ddId) {
                            window.ddId = ddId;
                            _this3.login({}, "2");
                        }).catch(function (err) {
                            _this3.$toast({ 'msg': err });
                        });
                    } else {
                        this.$durex.ddId().then(function (ddId) {
                            window.ddId = ddId;
                            _this3.login({}, "1");
                        }).catch(function (err) {
                            _this3.$toast({ 'msg': err });
                        });
                    }
                    break;
                case 1:
                    if (this.isRegister == 0) {
                        this.$durex.ddId().then(function (ddId) {
                            window.ddId = ddId;
                            _this3.beginRegister();
                        }).catch(function (err) {
                            _this3.$toast({ 'msg': err });
                        });
                    } else {
                        this.$durex.ddId().then(function (ddId) {
                            window.ddId = ddId;
                            _this3.login({}, "1");
                        }).catch(function (err) {
                            _this3.$toast({ 'msg': err });
                        });
                    }
                    break;
                case 2:
                    this.resetLoginPassword();
                    break;
            }
        },
        beginRegister: function beginRegister(v) {
            var _this4 = this;

            var seqNo = Object(__WEBPACK_IMPORTED_MODULE_3__utils_tool__["d" /* randomString */])(20);
            var nowParam = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                "ddId": window.ddId,
                "tel": this.phone,
                "loginName": this.phone,
                "password": Object(__WEBPACK_IMPORTED_MODULE_1__utils_rsa__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_js_md5___default()(this.password)),
                "verifyCode": this.code,
                'campaignNo': 'diandianguanwang',
                seqNo: seqNo
            }, v);

            __WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].axios({
                id: 'userAPI.register',
                param: nowParam
            }).then(function (res) {
                var data = res.data;
                _this4.$loading.end();
                if (data.code == '9003') {
                    _this4.$durex.show({
                        seqNo: seqNo,
                        scenarioId: 'diandian_register'
                    }, function (val) {
                        _this4.beginRegister(val);
                    });
                    return;
                }
                if (data.status == "SUCCESS") {
                    _this4.$storage.setItem('user', {
                        'accessKey': data.data.accessKey,
                        'userId': data.data.userId,
                        'thirdUserNo': data.data.thirdUserNo,
                        'phone': _this4.phone
                    });
                    _this4.regBox.isUserShow = true;
                    _this4.regBox.phone = _this4.phone;
                    _this4.regBoxData.regSuccess = true;
                } else {
                    _this4.$toast({ msg: data.message });
                }
            }).catch(function (error) {
                _this4.$loading.end();
                _this4.$toast({ msg: error.message });
            });
        },
        login: function login(v, loginType) {
            var _this5 = this;

            var seqNo = Object(__WEBPACK_IMPORTED_MODULE_3__utils_tool__["d" /* randomString */])(20);
            var nowParam = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                "ddId": window.ddId,
                "loginType": loginType,
                "mobile": this.phone,
                "loginPwd": Object(__WEBPACK_IMPORTED_MODULE_1__utils_rsa__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_js_md5___default()(this.password)),
                "verifyCode": this.code,
                seqNo: seqNo
            }, v);

            __WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].axios({
                id: 'userAPI.login',
                param: nowParam
            }).then(function (res) {
                _this5.$loading.end();
                var data = res.data;
                if (data.code == '9003') {
                    _this5.$durex.show({
                        seqNo: seqNo,
                        scenarioId: 'diandian_login'
                    }, function (val) {
                        _this5.login(val, loginType);
                    });
                    return;
                }
                if (data.status == "SUCCESS") {
                    _this5.$storage.setItem('user', {
                        'accessKey': data.data.accessKey,
                        'userId': data.data.userId,
                        'thirdUserNo': data.data.thirdUserNo,
                        'phone': _this5.phone
                    });
                    _this5.regBox.isUserShow = true;
                    _this5.regBox.phone = _this5.phone;
                    _this5.regBoxData.regSuccess = true;
                } else {
                    _this5.$toast({ msg: data.message });
                }
            }).catch(function (error) {
                _this5.$loading.end();
                _this5.$toast({ msg: error.message });
            });
        },
        resetLoginPassword: function resetLoginPassword() {
            var _this6 = this;

            var regData = {
                "mobile": this.phone,
                "password": Object(__WEBPACK_IMPORTED_MODULE_1__utils_rsa__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4_js_md5___default()(this.password)),
                "verifyCode": this.code,
                "passwordType": 0,
                "operationType": 1
            };
            regData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_tool__["a" /* filterData */])(regData);
            this.verifyOTP(function () {
                __WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].axios({
                    id: 'userAPI.resetLoginPassword',
                    param: regData
                }).then(function (res) {
                    _this6.$loading.end();
                    var data = res.data;
                    if (data.status == "SUCCESS") {
                        _this6.$toast({ msg: '重置密码成功，请重新登录' });
                        _this6.regBox.status = 0;
                        _this6.password = '';
                        _this6.isLogin = true;
                        _this6.regBoxData.isCode = false;
                        _this6.regBoxData.btnText = '登录';
                    } else {
                        _this6.$toast({ msg: data.message });
                    }
                }).catch(function (error) {
                    _this6.$loading.end();
                    _this6.$toast({ msg: error.message });
                });
            });
        },
        verifyOTP: function verifyOTP(fn) {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].axios({
                id: 'userAPI.verifyOTP',
                param: {
                    mobile: this.phone,
                    otpType: 2,
                    verifyCode: this.code
                }
            }).then(function (res) {
                var data = res.data;
                if (data.status == "SUCCESS") {
                    if (fn) fn.call(_this7);
                } else {
                    _this7.$loading.end();
                    _this7.$toast({ msg: data.message });
                }
            }).catch(function (error) {
                _this7.$loading.end();
                _this7.$toast({ msg: error.message });
            });
        }
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsencrypt__ = __webpack_require__(254);




var publicKey = '';
switch (__WEBPACK_IMPORTED_MODULE_0__config___default.a.ENV) {
    case '-test':
        publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDhpJTeVWB2e5qjJ44N6LDONb+T0T5yZEwcb/mx3xxSOrMYj4UlalJJxQjecQd0hsXmbSXSHyXkVKyAXzhlOlI1rk8H6kWyU1dEst+CkGaHUyRpF2fkGXs3cAuiz/t2G1g8zfSGVWGaU3jZIYd5n89myL4hLJ5L3zggXO4FDgrO9wIDAQAB';
        break;
    case '-uat':
        publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwqEycC4VPfioYwBmlx91er4mVKq+AcgDIiyDACumkTJ7LQk79ap0pO/cHhw4XlQHIfGP/B/7wUdirBxK7RbKx20a807JIQSXzEqdNFNhMvdIYss5c2Cu7KNCQ8luksr/b/Hp2UY3ov9OBScESWZ8DkEtHlQ9iaw1dtAWrwOCvTQIDAQAB';
        break;
    case '':
        publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDpmhiy1yLD0pKIXtgrzkFtQbWCwzulyKlzj2LM+7wYcFSDnR25JoFYTUm3Ozg0Jqd+ShFUn822A+aU3LLMHz+MDc+9EcVLRYnN2CW5WDL2spU6WlxkbNVUMUwShpOgdag4Nbo0VqFyqt/yrvN9p0irY7VfJFWV098wTQgBlX5d3QIDAQAB';
        break;
}

var PUBLIC_KEY = publicKey;

var Rsa = function Rsa(v) {
    var key = new __WEBPACK_IMPORTED_MODULE_1_jsencrypt__["a" /* JSEncrypt */]();
    var text = v;
    key.setPublicKey(PUBLIC_KEY);
    var encrypted = key.encrypt(text);
    return encrypted;
};

/* harmony default export */ __webpack_exports__["a"] = (Rsa);

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, exports) {

module.exports = {"version":"3.2.1"}

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.regBox.show) ? _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box-main"
  }, [_c('div', {
    staticClass: "header clearfix"
  }, [(!_vm.isLogin) ? _c('h2', [_vm._v(_vm._s(_vm.regBoxData.btnText))]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "h-list"
  }, [_c('h2', {
    class: {
      'active': _vm.hList[0]
    },
    on: {
      "click": _vm.passwordLoginHandle
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('h2', {
    class: {
      'active': _vm.hList[1]
    },
    on: {
      "click": _vm.codeLoginHandle
    }
  }, [_vm._v("短信登录")])]) : _vm._e(), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.regBoxCloseHandle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "m-l"
  }, [_c('div', {
    staticClass: "shh-bg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-r"
  }, [(!_vm.regBoxData.regSuccess) ? _c('div', {
    staticClass: "enter-contain"
  }, [_c('ul', [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "maxlength": 11,
      "placeholder": "手机号",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.regBoxData.isCode) ? _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "maxlength": 6,
      "placeholder": "验证码",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeMsg))])]) : _vm._e(), _vm._v(" "), (_vm.regBoxData.isPassword) ? _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "maxlength": 20,
      "placeholder": "密码",
      "type": "password",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.applyHandle
    }
  }, [_vm._v(_vm._s(_vm._f("cpText")(_vm.regBoxData.btnText)))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-text clearfix"
  }, [_c('p', {
    staticClass: "info fl"
  }, [_vm._v(_vm._s(_vm.regBoxData.infoText) + "？点我"), _c('b', {
    on: {
      "click": _vm.regHandle
    }
  }, [_vm._v(_vm._s(_vm.regBoxData.ciText))])]), _vm._v(" "), _c('p', {
    staticClass: "fr"
  }, [_c('i', {
    on: {
      "click": _vm.forgetPwdHandle
    }
  }, [_vm._v("忘记密码")])])])]) : _vm._e(), _vm._v(" "), (_vm.regBoxData.regSuccess) ? _c('div', {
    staticClass: "reg-success"
  }, [_c('h2', [_vm._v("欢迎加入点点大家庭！")]), _vm._v(" "), _c('p', [_vm._v("扫描二维码下载点点APP,立即领取您的额度！")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  })]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "fi-header"
  }, [_c('div', {
    staticClass: "hl"
  }), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }, [_c('ul', {
    staticClass: "link clearfix"
  }, _vm._l((_vm.headerText), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.headerActive[index]
      },
      on: {
        "click": function($event) {
          return _vm.headerHandle(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
  }), 0), _vm._v(" "), (!_vm.regBox.isUserShow) ? _c('div', {
    staticClass: "fun"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "btn login",
    on: {
      "click": _vm.loginHandle
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('li', {
    staticClass: "btn register",
    on: {
      "click": _vm.regHandle
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.regBox.isUserShow) ? _c('div', {
    staticClass: "login-box"
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.regBox.phone))]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.changeUserHandle
    }
  }, [_vm._v("切换账户")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])]) : _vm._e()])])]), _vm._v(" "), _c('reg-box', {
    attrs: {
      "reg-box": _vm.regBox
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      footerText: "Copyright © 169 2017 - 2018 Diandian 点点版权所有 粤ICP备17079095号-2"
    };
  },
  mounted: function mounted() {
    if (window.location.host == "www.bepoint.cn") {
      this.footerText = "深圳蜂点科技有限公司粤ICP备18073970号-1 <br />地址： 深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16<br />联系电话：0755-26647844";
    }
  },

  methods: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "fi-footer"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('h2', [_vm._v("关于我们")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("点点大事记")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/aboutus"
    }
  }, [_vm._v("点点愿景")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("帮助")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/helpcenter"
    }
  }, [_vm._v("帮助中心")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/helpcenter"
    }
  }, [_vm._v("意见反馈")])])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("客户服务")]), _vm._v(" "), _c('p', [_vm._v("客服热线：4000666122")]), _vm._v(" "), _c('p', [_vm._v("工作日9:00-18:00")])]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_vm._v("Copyright © 169 2017 - 2018 Diandian 点点版权所有 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备17079095号")]), _vm._v(" 深圳众联商务有限公司")])])])
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-pc"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "banner-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, _vm._l((_vm.page), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dh-page"
    }, [_c('span', {
      staticClass: "m-page"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-container"
  }, [_c('ul', _vm._l((_vm.navText), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.navActive[index]
      },
      on: {
        "click": function($event) {
          return _vm.paginationHandle(index)
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "version"
  }, [_c('ul', [_c('li', {
    on: {
      "mouseover": function($event) {
        return _vm.versionOverHandle(0)
      },
      "mouseout": _vm.versionOutHandle
    }
  }, [_c('div', {
    staticClass: "v-btn",
    class: {
      'active': _vm.isQrCode[0]
    }
  }, [_c('i'), _vm._v("IOS下载\n                        ")]), _vm._v(" "), (_vm.isQrCode[0]) ? _c('div', {
    staticClass: "qrcode-pic"
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    on: {
      "mouseover": function($event) {
        return _vm.versionOverHandle(1)
      },
      "mouseout": _vm.versionOutHandle
    }
  }, [_c('div', {
    staticClass: "v-btn",
    class: {
      'active': _vm.isQrCode[1]
    }
  }, [_c('i'), _vm._v("Android下载\n                        ")]), _vm._v(" "), (_vm.isQrCode[1]) ? _c('div', {
    staticClass: "qrcode-pic"
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "home-user"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "title-bg dd-title"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "title-bg hz-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "fd-icon"
  })], 1), _vm._v(" "), (_vm.isJgWin) ? _c('div', {
    staticClass: "dd-jg-win"
  }, [_c('div', {
    staticClass: "jg-main"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.isJgWin = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jg-bg"
  }), _vm._v(" "), _vm._m(4)])]) : _vm._e(), _vm._v(" "), _c('fi-footer')], 1) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-left"
  }, [_c('ul', [_c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("借点")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("想你所想,急你所急")]), _vm._v(" "), _c('p', [_vm._v("点一点，最高20万额度，日利息低至0.025%起，借10000最低每天只需2元利息。 资质达标1秒审核，3秒放款。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("潮流好物,应有尽有")]), _vm._v(" "), _c('p', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点闪付")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("与中国银联深度合作")]), _vm._v(" "), _c('p', [_vm._v("点一点，支持全国百万商户线上线下消费， 可享受支付立减专属优惠，安全、省心、省钱。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("生活缴费")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("足不出户,生活助手")]), _vm._v(" "), _c('p', [_vm._v("点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("娱乐充值")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("游戏、视频、礼品卡")]), _vm._v(" "), _c('p', [_vm._v("点一点，畅玩无限，享轻奢新主义， 为生活添色彩。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("办信用卡")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("精选各大银行易下好卡")]), _vm._v(" "), _c('p', [_vm._v("点一点，即刻在线完成申请， 额度大、颜值高、审批快、权益多, 让办卡不再困难。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-right"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-pro"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ly-container"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": "#/pdxy"
    }
  })])
}]}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(346),
  /* scopeId */
  "data-v-35412698",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fimark__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fimark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_fimark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footerMobile__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_headerMobile__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_headerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_headerMobile__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
    FiMark: __WEBPACK_IMPORTED_MODULE_3__components_fimark___default.a,
    FiFooterMobile: __WEBPACK_IMPORTED_MODULE_4__components_footerMobile___default.a,
    FiHeaderMobile: __WEBPACK_IMPORTED_MODULE_5__components_headerMobile___default.a
  },
  data: function data() {
    var _vue = this;
    return {
      isPc: false,
      isMobile: false,
      isShow: false,
      oMark: {
        show: false
      },
      isDianDianHome: false,
      isBepoint: false,
      swiperOption: {
        speed: 450,
        height: 420,
        autoplay: {
          delay: 4000
        },
        loop: false,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          slideChange: function slideChange(e) {},
          transitionEnd: function transitionEnd() {
            if (_vue.swiperOption.autoplay) {
              this.autoplay.start();
            }
          }
        }
      }
    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function mounted() {
    if (window.location.host == 'www.bepoint.cn') {
      document.title = '深圳蜂点科技有限公司';
      this.isBepoint = true;
    } else {
      document.title = '点点_点点app_点点官网';
      this.isDianDianHome = true;
    }
  },

  methods: {
    hideMarkHandle: function hideMarkHandle(val) {
      this.isShow = val;
    },
    downloadMobile: function downloadMobile() {
      var _this = this;

      var u = window.navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      console.log(u, isAndroid, isIOS);
      this.isLoading = true;

      if (isIOS) {
        window.location.href = "zldd://main";
        setTimeout(function () {
          _this.isLoading = false;
          window.location.href = "https://apps.apple.com/cn/app/%E6%8D%A1%E5%AF%8C%E5%AE%9D/id1466062624?from=singlemessage&isappinstalled=0";
        }, 1000);
      } else if (isAndroid) {
        if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
          window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
          return;
        }
        window.location.href = "zldd://main";
        setTimeout(function () {
          _this.isLoading = false;
          window.location.href = _this.diandianAndroidDownLoadUrl;
        }, 1000);
      }
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    props: {
        isMark: {
            Object: Object,
            default: function _default() {
                return {};
            }
        },
        isShow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        hideMark: function hideMark() {
            this.isMark.show = false;
        },
        listHandle: function listHandle() {
            this.isMark.show = false;
        }
    }
});

/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fimark"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMark.show),
      expression: "isMark.show"
    }],
    staticClass: "list-mark"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "list-icon",
    on: {
      "click": _vm.hideMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-icon"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "link-list"
  }, [_c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'flatindexmobile'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'aboutusmobile'
      }
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cooperatemobile'
      }
    }
  }, [_vm._v("商务合作")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.listHandle
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'helpcentermobile'
      }
    }
  }, [_vm._v("帮助中心")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      footerText: "Copyright &#169 2017 - 2018 Diandian<br /> 点点版权所有 粤ICP备17079095号-2"
    };
  },

  props: {
    isAdv: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    if (window.location.host == "www.bepoint.cn") {
      this.footerText = "深圳蜂点科技有限公司粤ICP备18073970号-1 <br />地址： 深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16<br />联系电话：0755-26647844";
    }
  },

  methods: {}
});

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.isAdv) ? _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top ys-icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "hz-main"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cus"
  }, [_c('h2', [_vm._v("客户服务")]), _vm._v(" "), _c('p', [_vm._v("客服热线：4000666122(工作日9:00-18:00)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "qrcode-main"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._v("Copyright © 169 2017 - 2018 Diandian 点点版权所有 "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备17079095号")]), _vm._v(" 深圳众联商务有限公司")])
}]}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tool__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isLogin: false,
            isLoginContainer: false
        };
    },

    props: {
        isMark: {
            Object: Object,
            default: function _default() {
                return {};
            }
        }
    },
    mounted: function mounted() {
        this.path = this.$route.path.replace('/', '');
        var urlParam = this.$route.query;

        if (urlParam.accessKey) {
            this.$storage.setItem('user', {
                'accessKey': urlParam.accessKey,
                'userId': urlParam.userId,
                'thirdUserNo': urlParam.thirdUserNo
            });
        }
        if (this.$storage.getItem('user').accessKey) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
    },

    methods: {
        showMark: function showMark() {
            this.isMark.show = true;
        },
        checkHandle: function checkHandle() {
            this.isLoginContainer = true;
        },
        logout: function logout() {
            this.$storage.init();
            this.isLogin = false;
            this.isLoginContainer = false;
        },
        changeUser: function changeUser() {
            this.loginForH5(this.path);
        },
        loginHandle: function loginHandle() {
            this.loginForH5(this.path);
        },
        finLogin: function finLogin(route) {
            var url = encodeURIComponent(window.location.protocol + '//' + window.location.host + window.location.pathname + '');
            var href = '';
            switch (__WEBPACK_IMPORTED_MODULE_0__config_js___default.a.ENV) {
                case '-test':
                    href = 'https://one-test.zhongan.com/sh/dd-login/#/index?redirect=';
                    break;
                case '-uat':
                    href = 'https://one-uat.zhongan.com/sh/dd-login/#/index?redirect=';
                    break;
                case '':
                    href = 'https://fin-app.zhongan.com/sh/dd-login/index.html#/index?redirect=';
                    break;
            }
            window.location.href = href + this.callBackUrl(route);
        },
        loginForH5: function loginForH5(route) {
            var url = '';
            switch (__WEBPACK_IMPORTED_MODULE_0__config_js___default.a.ENV) {
                case '-test':
                    if (window.location.href.indexOf('http://127.0.0.1') > -1) {
                        url = 'https://one-test.zhongan.com/account/nydd-service/index.html#/verify?campaignNo=diandianguanwang&callback=';
                    } else {
                        url = 'https://one-test.zhongan.com/fcp/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl=';
                    }
                    break;
                case '-uat':
                    url = 'https://one-uat.zhongan.com/fcp/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl=';
                    break;
                case '':
                    url = 'https://fin-app.zhongan.com/sh/diandian-oa/index.html#/?campaignNo=diandianguanwang&redirectUrl=';
                    break;
            }
            window.location.href = url + this.callBackUrl(route);
        },
        callBackUrl: function callBackUrl(route) {
            var cb = '';
            switch (__WEBPACK_IMPORTED_MODULE_0__config_js___default.a.ENV) {
                case '-test':
                    if (window.location.href.indexOf('http://127.0.0.1') > -1) {
                        cb = 'http://127.0.0.1:8087/#/' + route + '';
                    } else {
                        cb = 'https://one-test.zhongan.com/fcp/diandian-home/#/' + route + '';
                    }
                    break;
                case '-uat':
                    cb = 'https://one-uat.zhongan.com/fcp/diandian-home/#/' + route + '';
                    break;
                case '':
                    cb = 'https://www.diandian.com.cn/';
                    break;
            }
            return encodeURIComponent(cb);
        }
    }
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "list-icon",
    on: {
      "click": _vm.showMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [(!_vm.isLogin) ? _c('div', {
    on: {
      "click": _vm.loginHandle
    }
  }, [_c('span', [_vm._v("登录")]), _vm._v("|"), _c('span', [_vm._v("注册")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "login-icon",
    on: {
      "click": _vm.checkHandle
    }
  }, [_c('i')]) : _vm._e(), _vm._v(" "), (_vm.isLoginContainer) ? _c('div', {
    staticClass: "login-container"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.changeUser
    }
  }, [_vm._v("切换账号")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-main"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("年轻人的in生活指南")])]), _vm._v(" "), _c('span', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(162)
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('div', {
    staticClass: "home-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jy-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top hz-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "ys-main"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])])])
}]}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(350),
  /* scopeId */
  "data-v-01b7040a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fimark__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fimark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_fimark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footerMobile__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_headerMobile__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_headerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_headerMobile__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
        FiMark: __WEBPACK_IMPORTED_MODULE_3__components_fimark___default.a,
        FiFooterMobile: __WEBPACK_IMPORTED_MODULE_4__components_footerMobile___default.a,
        FiHeaderMobile: __WEBPACK_IMPORTED_MODULE_5__components_headerMobile___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            isShow: false,
            oMark: {
                show: false
            },
            isDianDianHome: false,
            isBepoint: false,
            isJgWinMob: true,
            swiperOption: {
                speed: 450,
                height: 420,
                autoplay: {
                    delay: 4000
                },
                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {},
                    transitionEnd: function transitionEnd() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start();
                        }
                    }
                }
            }
        };
    },

    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    mounted: function mounted() {
        if (window.location.host == 'www.bepoint.cn') {
            document.title = '深圳蜂点科技有限公司';
            this.isBepoint = true;
        } else {
            document.title = '点点_点点app_点点官网';
            this.isDianDianHome = true;
        }
    },

    methods: {
        hideMarkHandle: function hideMarkHandle(val) {
            this.isShow = val;
        },
        downloadMobile: function downloadMobile() {
            var _this = this;

            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            if (isIOS) {
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this.isLoading = false;
                    window.location.href = "https://apps.apple.com/cn/app/%E6%8D%A1%E5%AF%8C%E5%AE%9D/id1466062624?from=singlemessage&isappinstalled=0";
                }, 1000);
            } else if (isAndroid) {
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return;
                }
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this.isLoading = false;
                    window.location.href = _this.diandianAndroidDownLoadUrl;
                }, 1000);
            }
        }
    }
});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-main"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("借点")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("想你所想,及你所急")])]), _vm._v(" "), _c('span', [_vm._v("点一点，最高20万额度，日利息低至0.025%起，借10000最低每天只需2元利息。 资质达标1秒审核，3秒放款。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(351)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("年轻人的in生活指南")])]), _vm._v(" "), _c('span', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(162)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点闪付")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("与中国银联深度合作")])]), _vm._v(" "), _c('span', [_vm._v("点一点，支持全国百万商户线上线下消费， 可享受支付立减专属优惠， 安全、省心、省钱。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(352)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("生活缴费")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("足不出户，生活助手")])]), _vm._v(" "), _c('span', [_vm._v("点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(353)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("娱乐充值")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("游戏、视频、礼品卡")])]), _vm._v(" "), _c('span', [_vm._v("点一点，畅玩无限，享轻奢新主义， 为生活添色彩。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(354)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("办信用卡")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("精选各大银行易下好卡")])]), _vm._v(" "), _c('span', [_vm._v("点一点，即刻在线完成申请， 额度大、颜值高、审批快、权益多, 让办卡不再困难。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(355)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination my-swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('div', {
    staticClass: "home-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), (_vm.isJgWinMob) ? _c('div', {
    staticClass: "dd-jg-win-mob"
  }, [_c('div', {
    staticClass: "jg-main"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.isJgWinMob = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jg-bg"
  }), _vm._v(" "), _vm._m(2)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jy-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top hz-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "ys-main"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": "#/pdxy"
    }
  })])
}]}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-6.d73454b.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-2.009e79e.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-3.79742bb.png";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-4.5b6785b.png";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/mb-5.0479c69.png";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-30827b1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FiHeader: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a,
        FiFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            nowIndex: 0,
            page: 6,
            isMoveing: true,
            headerText: ['首页', '关于我们', '商务合作', '帮助中心'],
            headerActive: [true],
            navText: ['借点', '点点商城', '点点闪付', '生活缴费', '充值娱乐', '办信用卡'],
            navActive: [true],
            isQrCode: [false, false, false],
            swiperOption: {
                speed: 450,
                height: 420,

                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {},
                    transitionEnd: function transitionEnd() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start();
                        }
                    }
                }
            }
        };
    },
    created: function created() {
        document.title = '关于我们';
    },
    mounted: function mounted() {},

    methods: {}
});

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc aboutus-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "aboutus"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title ab-l"
  }, [_c('a', {
    attrs: {
      "name": "guyudd"
    }
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 0
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-0"
    }
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])]), _vm._v(" "), _c('div', {
    staticClass: "nr"
  }, [_vm._v("\n                                点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title ab-l"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 1
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-1"
    }
  }, [_vm._v("点点大事记")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])]), _vm._v(" "), _c('div', {
    staticClass: "shou-icon"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 2
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-2"
    }
  }, [_vm._v("点点愿景·一站式金融生活服务平台")]), _vm._v(" "), _c('p', [_vm._v("About Future·A One-stop Financial Service Platform")])]), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title ab-r"
  }, [_c('div', {
    staticClass: "js-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gc-icon"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("金融")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("商城")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("生活服务")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("充值缴费")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("休闲娱乐")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("线下服务")])])])])
}]}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  "data-v-b0944548",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_fimark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_headerMobile__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FiMark: __WEBPACK_IMPORTED_MODULE_1__components_fimark___default.a,
        FiFooterMobile: __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default.a,
        FiHeaderMobile: __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            oMark: {
                show: false
            }
        };
    },
    mounted: function mounted() {},

    methods: {
        hideMarkHandle: function hideMarkHandle(val) {
            thibs.isShow = val;
        }
    }
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutus-mobile"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("点点大事记")]), _vm._v(" "), _c('p', [_vm._v("Events Of D.Point")])])]), _vm._v(" "), _c('div', {
    staticClass: "dd-record"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.08.16")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.08.25")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("上线9天单日放款金额超100万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.11.27")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP用户破百万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2017.12.21")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("上线120天用户破200万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.03.20")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点商城上线，甄选正品好货")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.04.28")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点与中国银联达成战略合作，闪付功能上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.06.25")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点2.0版本全新上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.07.10")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("点点APP用户破1000万")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("2018.08.01")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("生活缴费功能上线")])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "dr-l"
  }, [_c('p', [_vm._v("至今")])]), _vm._v(" "), _c('div', {
    staticClass: "dr-r"
  }, [_c('p', [_vm._v("我们还在持续优化功能体验")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("点点愿景·一站式金融生活服务平台")]), _vm._v(" "), _c('p', [_vm._v("About Future·A One-stop Financial Service Platform")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-icon"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("金融")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("商城")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("生活服务")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("充值缴费")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("休闲娱乐")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-pt"
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("线下服务")])])])])])])])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  "data-v-24794792",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(79);






/* harmony default export */ __webpack_exports__["default"] = ({
    metaInfo: {
        title: '点点_点点app_点点官网_国内领先的智能生活金融服务平台',
        meta: [{
            name: 'keyWords',
            content: '点点，点点app，点点官网，点点贷怎么样，点点贷好不好，点点贷APP下载，点点信用贷款，点点借款靠谱吗'
        }]
    },
    components: {
        FiHeader: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a,
        FiFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            helpList: [{
                title: '点点是什么？',
                content: '点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。'
            }, {
                title: '借点的申请条件是？',
                content: '点点面向全国开放，只要持有中国第二代居民身份证、储蓄卡且年龄在21岁至55岁即可申请。'
            }, {
                title: '申请借点需要哪些流程？',
                content: '1. 手机注册登录<br />2. 填写个人资料，进行信用评估（额度实时评估）。请确保信息真实有效，上传信息已经过技术加密，请放心填写。<br />3. 选择借款金额及期限申请提现，资金会自动放款至绑定的信用卡或银行卡中。部分用户会有工作人员与您电话沟通审核，请注意021开头的来电。'
            }, {
                title: '申请借点需要哪些材料？',
                content: '1. 身份证<br />2. 信用卡、银行卡（借记卡非Ⅱ类卡）温馨提示：绑定储蓄卡不能为II类户。绑定II类户下的储蓄卡将会影响您的借款申请。如需确认储蓄卡是否为II类户，请致电开卡行客服确认。'
            }, {
                title: '借点如何还款？',
                content: '您在借款时需要绑定储蓄卡，点点默认在到期还款日从您的储蓄卡中扣除当期应还款项。请确保在还款日当日晚6点前还款卡中余额充足。您也可以通过登录点点App，发起主动还款。'
            }, {
                title: '如何查询交易记录/账单？',
                content: '如您已成功申请借款，您可以在登录点点APP之后点击右上角图标，点击【交易记录】，了解您的借款及还款情况。'
            }, {
                title: '商城的商品是从哪里进货的？是真品和正品吗？',
                content: '商城的商品有双重正品权益保障：<br />1、点点只会向金融机构或上市公司签约的供应商采购并销售商品，且每月对供应商的商品质量做抽查审核，保障用户的权益。<br />2、所有商品均由众安保险提供《正品交易履约保证保险》，对于认证的非正品商品，提供最高上万元的赔付保障。'
            }, {
                title: '如何保障我的资金安全？',
                content: '在安全保障方面我们采用最为先进的安全技术，并且所有信息均为加密存储，保证信息交换及存储过程的安全性，保护您的信息安全。'
            }, {
                title: '如何注销账户？',
                content: '申请注销账户之前，请确保您注销账户前需保证您在点点上购买的商品、享受的服务等已终止，且不存在对点点或交易相对方应承担的违约或侵权责任。符合以上条件，可以通过电话客服咨询相关注销事宜，由工作人员协助解决。'
            }],
            helpChildList: 2,
            activeArr: [],
            activeTreeArr: [],
            cfNum: -1,
            cfNum3: -1,
            title: '',
            content: ''
        };
    },
    created: function created() {
        document.title = '帮助中心';
    },
    mounted: function mounted() {
        this.tree = document.getElementsByClassName('tree');
        this.treeContent = document.getElementsByClassName('tree-content');
        this.parentRri = document.getElementsByClassName('parentTri');
    },

    methods: {
        sendHandle: function sendHandle() {
            var _this = this;

            if (!this.$storage.getItem('user').accessKey) {
                this.$toast({
                    msg: '请先登录账号'
                });
                return;
            }
            if (this.title.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题'
                });
                return;
            }
            if (this.content.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题描述'
                });
                return;
            }
            this.$loading();
            __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].axios({
                id: 'userAPI.feedBackQuestion',
                param: {
                    title: this.title,
                    content: this.content,
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo
                }
            }).then(function (res) {
                _this.$loading.end();
                var data = res.data;
                if (data.status == "SUCCESS") {
                    _this.$toast({
                        msg: '提交成功'
                    });
                    _this.title = '';
                    _this.content = '';
                } else {
                    _this.$toast({
                        msg: '查询接口失败'
                    });
                }
            }).catch(function (error) {
                _this.$loading.end();
                _this.$toast({
                    msg: error.message
                });
            });
        },
        tmpHandle: function tmpHandle(index) {
            if (this.cfNum1 != index) {
                this.activeArr = [];
                this.activeArr[index] = true;
                this.cfNum1 = index;
            } else {
                this.activeArr = [];
                this.activeArr[this.cfNum1] = false;
                this.cfNum1 = -1;
            }
        },
        clickHelpListHandle: function clickHelpListHandle(index) {
            if (!this.tree[index].boolen) {
                this.addClass(this.parentRri[index], 'active');
                console.log(index, this.treeContent[index].offsetHeight);
                this.tree[index].style.height = this.treeContent[index].offsetHeight + 'px';
                this.tree[index].boolen = true;
                this.queryHelpCenterList(this.helpList[index].categoryId);
            } else {
                this.removeClass(this.parentRri[index], 'active');
                this.tree[index].style.height = 0 + 'px';
                this.tree[index].boolen = false;
            }
        },
        tree2Handle: function tree2Handle(index, ev) {
            var nowTri = ev.currentTarget.getElementsByClassName('childTri')[0];

            this.tree2 = ev.currentTarget.parentNode.getElementsByClassName('tree2')[0];
            this.tree2Content = ev.currentTarget.parentNode.getElementsByClassName('tree2-content')[0];
            if (!this.tree2.boolen) {
                this.addClass(nowTri, 'active');
                this.tree[index].style.height = this.treeContent[index].offsetHeight + this.tree2Content.offsetHeight + 'px';
                this.tree2.style.height = this.tree2Content.offsetHeight + 'px';
                this.tree2.boolen = true;
            } else {
                this.removeClass(nowTri, 'active');
                this.tree[index].style.height = this.treeContent[index].offsetHeight - this.tree2Content.offsetHeight + 'px';
                this.tree2.style.height = 0 + 'px';
                this.tree2.boolen = false;
            }
        },
        addClass: function addClass(obj, sClass) {
            if (obj.className) {
                obj.className += ' ' + sClass;
            } else {
                obj.className += sClass;
            }
        },
        removeClass: function removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "");
        },
        queryHelpCenterCategoryList: function queryHelpCenterCategoryList(fn) {
            var _this2 = this;

            this.$loading();
            __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].ddcms({
                id: 'cmsAPI.queryHelpCenterCategoryList',
                param: {
                    status: '1000'
                }
            }).then(function (res) {
                _this2.$loading.end();
                if (res.data.code == "1") {
                    var dataList = res.data.data.data;

                    var categoryList = [];
                    dataList.forEach(function (e) {
                        if (e.status == 1000) {
                            categoryList.push({
                                categoryName: e.categoryName,
                                categoryId: e.id
                            });
                        }
                    });
                    _this2.helpList = categoryList;
                    if (fn) fn.call(_this2);
                    console.log(categoryList, 'categoryList');
                } else {
                    _this2.$toast({
                        msg: '查询接口失败'
                    });
                }
            }).catch(function (error) {
                _this2.$loading.end();
                _this2.$toast({
                    msg: error.message
                });
            });
        },
        queryHelpCenterList: function queryHelpCenterList(id) {
            var _this3 = this;

            this.$loading();
            __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].ddcms({
                id: 'cmsAPI.queryHelpCenterList',
                param: {
                    "categoryId": id,
                    "status": "1000"
                }
            }).then(function (res) {
                _this3.$loading.end();
                if (res.data.code == "1") {
                    var dataList = res.data.data.data;

                    var titleContentList = [];
                    dataList.forEach(function (e) {
                        titleContentList.push({
                            'title': e.title,
                            'context': e.context
                        });
                    });
                    _this3.helpChildList = titleContentList;
                } else {
                    _this3.$toast({
                        msg: '查询接口失败'
                    });
                }
            }).catch(function (error) {
                _this3.$loading.end();
                _this3.$toast({
                    msg: error.message
                });
            });
        }
    }
});

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc helpcenter-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "helpcenter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "help-content"
  }, [_c('ul', _vm._l((_vm.helpList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "h-top",
      on: {
        "click": function($event) {
          return _vm.tmpHandle(index)
        }
      }
    }, [_c('i', {
      staticClass: "parentTri",
      class: {
        'active': _vm.activeArr[index]
      }
    }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "help-item",
      class: {
        'active': _vm.activeArr[index]
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "question fl"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "placeholder": "请输入您的问题",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flat-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_c('span', [_vm._v("提交")]), _c('i')])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('a', [_vm._v("在线客服")]), _vm._v(" "), _c('p', [_vm._v("Online Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "nr fl"
  }, [_vm._v("点击在线咨询按钮，连接人工客服。")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "online-consult"
  }, [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("常见问题")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("获取支持")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])]), _vm._v(" "), _c('div', {
    staticClass: "nr fl"
  }, [_vm._v("客服热线：4000666122(工作日9:00-18:00)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("意见反馈")]), _vm._v(" "), _c('p', [_vm._v("Suggestions")])])])
}]}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  "data-v-65c2968e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_fimark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_headerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_axios__ = __webpack_require__(79);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FiMark: __WEBPACK_IMPORTED_MODULE_1__components_fimark___default.a,
        FiFooterMobile: __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default.a,
        FiHeaderMobile: __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            helpList: [{
                title: '点点是什么？',
                content: '点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。'
            }, {
                title: '借点的申请条件是？',
                content: '点点面向全国开放，只要持有中国第二代居民身份证、储蓄卡且年龄在21岁至55岁即可申请。'
            }, {
                title: '申请借点需要哪些流程？',
                content: '1. 手机注册登录<br />2. 填写个人资料，进行信用评估（额度实时评估）。请确保信息真实有效，上传信息已经过技术加密，请放心填写。<br />3. 选择借款金额及期限申请提现，资金会自动放款至绑定的信用卡或银行卡中。部分用户会有工作人员与您电话沟通审核，请注意021开头的来电。'
            }, {
                title: '申请借点需要哪些材料？',
                content: '1. 身份证<br />2. 信用卡、银行卡（借记卡非Ⅱ类卡）温馨提示：绑定储蓄卡不能为II类户。绑定II类户下的储蓄卡将会影响您的借款申请。如需确认储蓄卡是否为II类户，请致电开卡行客服确认。'
            }, {
                title: '借点如何还款？',
                content: '您在借款时需要绑定储蓄卡，点点默认在到期还款日从您的储蓄卡中扣除当期应还款项。请确保在还款日当日晚6点前还款卡中余额充足。您也可以通过登录点点App，发起主动还款。'
            }, {
                title: '如何查询交易记录/账单？',
                content: '如您已成功申请借款，您可以在登录点点APP之后点击右上角图标，点击【交易记录】，了解您的借款及还款情况。'
            }, {
                title: '商城的商品是从哪里进货的？是真品和正品吗？',
                content: '商城的商品有双重正品权益保障：<br />1、点点只会向金融机构或上市公司签约的供应商采购并销售商品，且每月对供应商的商品质量做抽查审核，保障用户的权益。<br />2、所有商品均由众安保险提供《正品交易履约保证保险》，对于认证的非正品商品，提供最高上万元的赔付保障。'
            }, {
                title: '如何保障我的资金安全？',
                content: '在安全保障方面我们采用最为先进的安全技术，并且所有信息均为加密存储，保证信息交换及存储过程的安全性，保护您的信息安全。'
            }, {
                title: '如何注销账户？',
                content: '申请注销账户之前，请确保您注销账户前需保证您在点点上购买的商品、享受的服务等已终止，且不存在对点点或交易相对方应承担的违约或侵权责任。符合以上条件，可以通过电话客服咨询相关注销事宜，由工作人员协助解决。'
            }],
            activeArr: [],
            cfNum: -1,
            title: '',
            content: '',
            oMark: {
                show: false
            }
        };
    },
    mounted: function mounted() {
        document.title = "帮助中心";
    },

    methods: {
        sendHandle: function sendHandle() {
            var _this = this;

            if (!this.$storage.getItem('user').accessKey) {
                this.$toast({
                    msg: '请先登录账号'
                });
                return;
            }
            if (this.title.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题'
                });
                return;
            }
            if (this.content.trim() == '') {
                this.$toast({
                    msg: '请输入您的问题描述'
                });
                return;
            }
            this.$loading();
            __WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].axios({
                id: 'userAPI.feedBackQuestion',
                param: {
                    title: this.title,
                    content: this.content,
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo
                }
            }).then(function (res) {
                _this.$loading.end();
                var data = res.data;
                if (data.status == "SUCCESS") {
                    _this.$toast({
                        msg: '提交成功'
                    });
                    _this.title = '';
                    _this.content = '';
                } else {
                    _this.$toast({
                        msg: '查询接口失败'
                    });
                }
            }).catch(function (error) {
                _this.$loading.end();
                _this.$toast({
                    msg: error.message
                });
            });
        },
        hideMarkHandle: function hideMarkHandle(val) {
            this.isShow = val;
        },
        clickHelpListHandle: function clickHelpListHandle(index) {
            if (this.cfNum1 != index) {
                this.activeArr = [];
                this.activeArr[index] = true;
                this.cfNum1 = index;
            } else {
                this.activeArr = [];
                this.activeArr[this.cfNum1] = false;
                this.cfNum1 = -1;
            }
        }
    }
});

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aboutus-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "help-list"
  }, [_c('ul', _vm._l((_vm.helpList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.clickHelpListHandle(index)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "help-item",
      class: {
        'active': _vm.activeArr[index]
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "arrow",
      class: {
        'acitve': _vm.activeArr[index]
      }
    })])
  }), 0)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "suggestions"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "placeholder": "请输入您的问题",
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.sendHandle
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('fi-footer-mobile', {
    attrs: {
      "is-adv": false
    }
  }), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("Online Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        点击在线咨询按钮，连接人工客服。\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "online-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("常见问题")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("获取支持")]), _vm._v(" "), _c('p', [_vm._v("Get Support")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        客服热线：4000666122(工作日9:00-18:00)\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("意见反馈")]), _vm._v(" "), _c('p', [_vm._v("Suggestions")])])])
}]}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-681f7767",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(79);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FiHeader: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a,
        FiFooter: __WEBPACK_IMPORTED_MODULE_2__components_footer___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            helpList: 4,
            activeArr: [],
            cfNum: -1,
            name: '',
            companyName: '',
            phone: '',
            email: '',
            description: ''
        };
    },
    created: function created() {
        document.title = '商务合作';
    },
    mounted: function mounted() {},

    methods: {
        clickHelpListHandle: function clickHelpListHandle(index) {
            if (this.cfNum1 != index) {
                this.activeArr = [];
                this.activeArr[index] = true;
                this.cfNum1 = index;
            } else {
                this.activeArr = [];
                this.activeArr[this.cfNum1] = false;
                this.cfNum1 = -1;
            }
        },
        sendHandle: function sendHandle() {
            var _this = this;

            if (this.name.trim() == '') {
                this.$toast({ msg: '请输入您的名称' });
                return;
            }
            if (this.companyName.trim() == '') {
                this.$toast({ msg: '请输入您的公司' });
                return;
            }
            if (this.phone.trim() == '') {
                this.$toast({ msg: '请输入您的电话' });
                return;
            }
            if (this.email.trim() == '') {
                this.$toast({ msg: '请输入您的邮箱' });
                return;
            }
            if (this.description.trim() == '') {
                this.$toast({ msg: '请输入您的描述问题' });
                return;
            }
            this.$loading();
            __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].axios({
                id: 'officialWebsiteAPI.sendEmail',
                param: {
                    name: this.name,
                    companyName: this.companyName,
                    phone: this.phone,
                    email: this.email,
                    description: this.description,
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo
                }
            }).then(function (res) {
                _this.$loading.end();
                var data = res.data;
                if (data.status == "SUCCESS") {
                    console.log(data, 'data');
                    _this.$toast({ msg: '提交成功' });
                    _this.name = '';
                    _this.companyName = '';
                    _this.phone = '';
                    _this.email = '';
                    _this.description = '';
                } else {
                    if (data.code == "2200") {
                        _this.$toast({ msg: '登录信息超时，请重新登录' });
                        _this.$storage.init();
                        setTimeout(function () {
                            window.location.reload();
                        }, 300);
                        return;
                    }
                    _this.$toast({ msg: data.message });
                }
            }).catch(function (error) {
                _this.$loading.end();
                _this.$toast({ msg: error.message });
            });
        }
    }
});

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc cooperate-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "cooperate"
  }, [_c('div', {
    staticClass: "dd-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-list"
  }, [_c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "placeholder": "",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bew clearfix"
  }, [_c('div', {
    staticClass: "item brief"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "enter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "flat-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_c('span', [_vm._v("发送")]), _c('i')])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("姓名")]), _vm._v(" "), _c('span', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("公司")]), _vm._v(" "), _c('span', [_vm._v("ITD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("电话")]), _vm._v(" "), _c('span', [_vm._v("Call")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("邮箱")]), _vm._v(" "), _c('span', [_vm._v("E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('h2', [_vm._v("描述")]), _vm._v(" "), _c('span', [_vm._v("Brief")])])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  "data-v-45e5abe9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fimark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_fimark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_footerMobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_headerMobile__);







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FiMark: __WEBPACK_IMPORTED_MODULE_1__components_fimark___default.a,
        FiFooterMobile: __WEBPACK_IMPORTED_MODULE_2__components_footerMobile___default.a,
        FiHeaderMobile: __WEBPACK_IMPORTED_MODULE_3__components_headerMobile___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            helpList: 4,
            activeArr: [],
            cfNum: -1,
            name: '',
            companyName: '',
            phone: '',
            email: '',
            description: '',
            oMark: {
                show: false
            }
        };
    },
    mounted: function mounted() {
        document.title = "商务合作";
    },

    methods: {
        hideMarkHandle: function hideMarkHandle(val) {
            this.isShow = val;
        },
        clickHelpListHandle: function clickHelpListHandle(index) {
            if (this.cfNum1 != index) {
                this.activeArr = [];
                this.activeArr[index] = true;
                this.cfNum1 = index;
            } else {
                this.activeArr = [];
                this.activeArr[this.cfNum1] = false;
                this.cfNum1 = -1;
            }
        },
        sendHandle: function sendHandle() {
            var _this = this;

            if (this.name.trim() == '') {
                this.$toast({ msg: '请输入您的名称' });
                return;
            }
            if (this.companyName.trim() == '') {
                this.$toast({ msg: '请输入您的公司' });
                return;
            }
            if (this.phone.trim() == '') {
                this.$toast({ msg: '请输入您的电话' });
                return;
            }
            if (this.email.trim() == '') {
                this.$toast({ msg: '请输入您的邮箱' });
                return;
            }
            if (this.description.trim() == '') {
                this.$toast({ msg: '请输入您的描述问题' });
                return;
            }

            this.$loading();
            api.axios({
                id: 'officialWebsiteAPI.sendEmail',
                param: {
                    name: this.name,
                    companyName: this.companyName,
                    phone: this.phone,
                    email: this.email,
                    description: encodeURIComponent(this.description),
                    'accessKey': this.$storage.getItem('user').accessKey,
                    'userId': this.$storage.getItem('user').userId,
                    'thirdUserNo': this.$storage.getItem('user').thirdUserNo
                }
            }).then(function (res) {
                _this.$loading.end();
                var data = res.data;
                if (data.status == "SUCCESS") {
                    console.log(data, 'data');
                    _this.$toast({ msg: '提交成功' });
                    _this.name = '';
                    _this.companyName = '';
                    _this.phone = '';
                    _this.email = '';
                    _this.description = '';
                } else {
                    if (data.code == "2200") {
                        _this.$toast({ msg: '登录信息超时，请重新登录' });
                        _this.$storage.init();
                        setTimeout(function () {
                            window.location.reload();
                        }, 300);
                        return;
                    }
                    _this.$toast({ msg: data.message });
                }
            }).catch(function (error) {
                _this.$loading.end();
                _this.$toast({ msg: error.message });
            });
        }
    }
});

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-mobile"
  }, [_c('div', {
    staticClass: "dd-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cooperate-main"
  }, [_c('div', {
    staticClass: "cm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "maxlength": 8,
      "placeholder": "请输入您的姓名",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入您的公司",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "maxlength": 11,
      "placeholder": "请输入您的电话",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "maxlength": 100,
      "placeholder": "请输入您的邮箱",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "cm-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "maxlength": 500,
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cm-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), _c('fi-footer-mobile', {
    attrs: {
      "is-adv": false
    }
  }), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("姓名")]), _vm._v(" "), _c('p', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("公司")]), _vm._v(" "), _c('p', [_vm._v("ITD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("电话")]), _vm._v(" "), _c('p', [_vm._v("Call")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("邮箱")]), _vm._v(" "), _c('p', [_vm._v("E-mail")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-left"
  }, [_c('h2', [_vm._v("描述")]), _vm._v(" "), _c('p', [_vm._v("Brief")])])
}]}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-9ea5ceee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tool__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_footer__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"],
        FiHeader: __WEBPACK_IMPORTED_MODULE_3__components_header___default.a,
        FiFooter: __WEBPACK_IMPORTED_MODULE_4__components_footer___default.a
    },
    data: function data() {
        var _vue = this;
        return {
            isPc: false,
            isMobile: false,
            nowIndex: 0,
            page: 2,
            isMoveing: true,
            navText: ['点点商城', '生活缴费'],
            navActive: [true],
            isQrCode: [false, false, false],
            tapTimer: null,
            isDianDianHome: false,
            isBepoint: false,
            swiperOption: {
                speed: 450,
                height: 420,

                loop: true,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function slideChange(e) {},
                    transitionEnd: function transitionEnd() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start();
                        }
                    }
                }
            }
        };
    },

    computed: {
        swiper: function swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },
    watch: {
        nowIndex: function nowIndex(n, o) {
            cancelAnimationFrame(this.aMPage[o].raf);

            this.navActive = [];
            this.navActive[n] = true;
            this.aMPage[o].style[this.transform] = 'translate3d(-100%,0,0)';
            this.moveBar(this.aMPage[n], 0, 6000);
            this.bannerMoveHandle(n, o);
        }
    },
    created: function created() {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isIos || Object(__WEBPACK_IMPORTED_MODULE_2__utils_tool__["c" /* os */])().isAndroid) {
            this.isMobile = true;
        } else {
            this.isPc = true;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        if (window.location.host == 'www.bepoint.cn') {
            document.title = '深圳蜂点科技有限公司';
            this.isBepoint = true;
        } else {
            document.title = '点点_点点app_点点官网_国内领先的智能生活金融服务平台';
            this.isDianDianHome = true;
            this.$nextTick(function () {
                _this2.bannerLeft = document.getElementsByClassName('banner-left')[0];
                _this2.leftLi = _this2.bannerLeft.getElementsByTagName('li');
                _this2.bannerRight = document.getElementsByClassName('banner-right')[0];
                _this2.rightLi = _this2.bannerRight.getElementsByTagName('li');

                _this2.pfx();
                _this2.initElement();
            });
        }
    },

    methods: {
        pfx: function pfx() {
            var prefix = function () {
                var tempDom = document.createElement('div').style,
                    prefixStrArr = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                    sPre;
                for (var i = 0; i < prefixStrArr.length; i++) {
                    if (prefixStrArr[i] + 'ransform' in tempDom) {
                        sPre = prefixStrArr[i].substring(0, prefixStrArr[i].length - 1);
                        window.cssPrefix = sPre ? sPre : '';
                        window.css_Prefix = sPre ? '-' + sPre.toLowerCase() + '-' : '';
                    }
                }
                tempDom = null;
                return function (style) {
                    if (sPre === '') return style;
                    style = style.charAt(0).toUpperCase() + style.substring(1);
                    return sPre + style;
                };
            }();
            var _vTransitionEnd = {
                '': 'transitionend',
                'webkit': 'webkitTransitionEnd',
                'Moz': 'transitionend',
                'O': 'otransitionend',
                'ms': 'MSTransitionEnd'
            };
            this.transform = prefix('transform');
            this.transition = prefix('transition');
            this.transitionEnd = _vTransitionEnd[window.cssPrefix];
            var transitionDelay = prefix('transitionDelay'),
                transitionDuration = prefix('transitionDuration'),
                transitionProperty = prefix('transitionProperty'),
                transitionTimingFunction = prefix('transitionTimingFunction');
        },
        initElement: function initElement() {
            this.aMPage = document.getElementsByClassName('m-page');
            this.moveBar(this.aMPage[0], 0, 6000);
        },
        moveFn: function moveFn() {
            this.isMoveing = true;
        },
        versionOverHandle: function versionOverHandle(index) {
            this.isQrCode = [false, false, false];
            this.isQrCode[index] = true;
        },
        versionOutHandle: function versionOutHandle() {
            this.isQrCode = [];
        },
        bannerMoveHandle: function bannerMoveHandle(n, o) {
            var _this3 = this;

            for (var i = 0; i < this.leftLi.length; i++) {
                this.leftLi[i].className = '';
            }
            this.leftLi[o].style[this.transform] = 'translate3d(0,0,0)';
            this.leftLi[o].style['opacity'] = '1';
            this.leftLi[n].style[this.transform] = 'translate3d(0,288px,0)';
            this.leftLi[n].style['opacity'] = '0';

            for (var i = 0; i < this.rightLi.length; i++) {
                this.rightLi[i].className = '';
            }
            this.rightLi[o].style[this.transform] = 'translate3d(0,0,0)';
            this.rightLi[o].style['opacity'] = '1';
            this.rightLi[n].style[this.transform] = 'translate3d(680px,0,0)';
            this.rightLi[n].style['opacity'] = '0';

            clearTimeout(this.tapTimer);
            this.tapTimer = setTimeout(function () {
                _this3.addClass(_this3.leftLi[o], 'transition-y-start');
                _this3.addClass(_this3.leftLi[n], 'transition-y-start');
                _this3.addClass(_this3.rightLi[o], 'transition-x-start');
                _this3.addClass(_this3.rightLi[n], 'transition-x-start');

                _this3.leftLi[o].style[_this3.transform] = 'translate3d(0,-288px,0)';
                _this3.leftLi[o].style['opacity'] = '0';
                _this3.leftLi[n].style[_this3.transform] = 'translate3d(0,0,0)';
                _this3.leftLi[n].style['opacity'] = '1';

                _this3.rightLi[o].style[_this3.transform] = 'translate3d(-680px,0,0)';
                _this3.rightLi[o].style['opacity'] = '0';
                _this3.rightLi[n].style[_this3.transform] = 'translate3d(0px,0,0)';
                _this3.rightLi[n].style['opacity'] = '1';

                var _this = _this3;
                _this3.leftLi[n].removeEventListener(_this.transitionEnd, _this.moveFn, false);
                _this3.leftLi[n].addEventListener(_this.transitionEnd, _this.moveFn, false);
            }, 30);
        },
        paginationHandle: function paginationHandle(index) {
            if (this.isMoveing) {
                this.nowIndex = index;
                this.navActive = [];
                this.navActive[index] = true;
                this.isMoveing = false;
            }
        },
        scrollHandle: function scrollHandle() {
            var _this4 = this;

            window.addEventListener('scroll', function () {
                var nowScrollTop = document.documentElement.scrollTop + document.body.scrollTop;

                if (nowScrollTop > 0) {
                    _this4.isFixed = true;
                } else {
                    _this4.isFixed = false;
                }
            }, false);
        },
        moveBar: function moveBar(obj, target, time) {
            var _this5 = this;

            if (obj.raf) cancelAnimationFrame(obj.raf);

            var startTime = Date.now();
            var time = time;
            var curNum = -100;
            var target = target;

            var tween = {
                linear: function linear(t, b, c, d) {
                    return c * t / d + b;
                },
                easeInQuad: function easeInQuad(t, b, c, d) {
                    return c * (t /= d) * t + b;
                },
                easeOutQuad: function easeOutQuad(t, b, c, d) {
                    return -c * (t /= d) * (t - 2) + b;
                },
                easeInOutQuad: function easeInOutQuad(t, b, c, d) {
                    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                    return -c / 2 * (--t * (t - 2) - 1) + b;
                }
            };

            var run = function run() {
                var changeTime = Date.now() - startTime;
                if (changeTime >= time) {
                    changeTime = time;
                }
                var value = tween.linear(changeTime, curNum, target - curNum, time);

                obj.style[_this5.transform] = 'translate3d(' + value + '%,0,0)';
                if (changeTime == time) {
                    if (_this5.nowIndex >= _this5.aMPage.length - 1) {
                        _this5.nowIndex = 0;
                    } else {
                        _this5.nowIndex++;
                    }
                    cancelAnimationFrame(obj.raf);
                } else {
                    cancelAnimationFrame(obj.raf);
                    obj.raf = requestAnimationFrame(run);
                }
            };
            run();
        },
        downloadMobile: function downloadMobile() {
            var _this6 = this;

            var u = window.navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            console.log(u, isAndroid, isIOS);
            this.isLoading = true;

            if (isIOS) {
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this6.isLoading = false;
                    window.location.href = "https://itunes.apple.com/us/app/%E7%82%B9%E7%82%B9-%E7%82%B9%E4%B8%80%E7%82%B9%E5%B0%B1%E6%9C%89%E9%92%B1/id1259010187?l=zh&ls=1&mt=8";
                }, 1000);
            } else if (isAndroid) {
                if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                    window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.zhonglian.diandian";
                    return;
                }
                window.location.href = "zldd://main";
                setTimeout(function () {
                    _this6.isLoading = false;
                    window.location.href = _this6.diandianAndroidDownLoadUrl;
                }, 1000);
            }
        },
        addClass: function addClass(obj, sClass) {
            if (obj.className.indexOf(sClass) == -1) {
                if (obj.className) {
                    obj.className += ' ' + sClass;
                } else {
                    obj.className += sClass;
                }
            }
        },
        removeClass: function removeClass(obj, sClass) {
            var aClass = obj.className.split(' ');
            for (var i = 0; i < aClass.length; i++) {
                if (aClass[i] == sClass) {
                    aClass[i] = '';
                }
            }
            obj.className = aClass.join(' ').replace(/(^\s*)|(\s*$)/g, "");
        }
    }
});

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-pc"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "banner-container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, _vm._l((_vm.page), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dh-page"
    }, [_c('span', {
      staticClass: "m-page"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-container"
  }, [_c('ul', _vm._l((_vm.navText), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.navActive[index]
      },
      on: {
        "click": function($event) {
          return _vm.paginationHandle(index)
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "home-user"
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "fi-footer"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "footer-text",
    domProps: {
      "innerHTML": _vm._s('Copyright © 169 2017 - 2018 Diandiango 点点GO版权所有 粤ICP备17079095号-2')
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fi-header"
  }, [_c('h2', {
    staticClass: "dd-go"
  }, [_vm._v("点点GO")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-left"
  }, [_c('ul', [_c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("潮流好物,应有尽有")]), _vm._v(" "), _c('p', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")])]), _vm._v(" "), _c('li', [_c('div', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("生活缴费")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('strong', [_vm._v("足不出户,生活助手")]), _vm._v(" "), _c('p', [_vm._v("点一点，所有水、电、煤等生活缴费， 在手机上即可完成。 生活已然艰辛，点点为您省心。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-right"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-pro"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])
}]}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {
            msg: ''
        };
    },
    mounted: function mounted() {}
});

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "jg-main-page"
  }, [_c('div', {
    staticClass: "jg-bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(388)
    }
  })])])])])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/jg-bg.619ab62.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {},
    data: function data() {
        return {
            msg: ''
        };
    },
    mounted: function mounted() {},
    methods: function methods() {}
});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pdyx"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(393),
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/my-xy.67f5d3d.png";

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, opt) {
        var loadingMark = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);

        this.domLoadList = [];
        var _this = this;
        function $loading(param) {
            var nowLoading = new loadingMark();

            nowLoading.$mount();

            _this.domLoadList.push(nowLoading.$el);

            document.querySelector(opt.container).appendChild(nowLoading.$el);
            $loading.end = function (p) {
                if (_this.domLoadList[0]) {
                    document.querySelector(opt.container).removeChild(_this.domLoadList[0]);
                    _this.domLoadList.splice(0, 1);
                }
            };
        }
        Vue.loading = Vue.prototype.$loading = $loading;
    }
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(599)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  "data-v-696d3b1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShow: false,
            msg: 'loading'
        };
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.isShow = true;
        }, 0);
    }
});

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "loading-main"
  }, [_c('div', {
    staticClass: "loading",
    class: {
      'show': _vm.isShow
    }
  }, [_c('div', {
    staticClass: "loading-gif animation_x"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])])])
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, opt) {
        var toastMark = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
        this.domLoadList = [];
        this.cashMsg = '';
        var _this = this;
        function $toast(param) {
            var toast = new toastMark();

            toast.msg = param.msg;
            toast.time = param.time || 1500;
            toast.$mount();

            if (toast.msg == _this.cashMsg) {
                return;
            }

            _this.domLoadList.push(toast.$el);

            document.querySelector(opt.container).appendChild(toast.$el);
            _this.cashMsg = toast.msg;
            toast.$el.timer = setTimeout(function () {
                if (_this.domLoadList[0]) {
                    document.querySelector(opt.container).removeChild(_this.domLoadList[0]);
                    _this.domLoadList.splice(0, 1);
                    _this.cashMsg = '';
                }
            }, toast.time);
        }
        $toast.end = function (p) {};
        Vue.toast = Vue.prototype.$toast = $toast;
    }
});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  "data-v-9fd28070",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShow: false
        };
    },

    props: {
        msg: {
            type: String,
            default: ''
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.isShow = true;
        }, 0);
    },

    methods: {}
});

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "toast",
    class: {
      'show': _vm.isShow
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])])])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);



var key = '_diandian_OA';

var storage = {
    init: function init() {
        var init = {
            user: ''
        };
        init = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(init);
        localStorage.setItem(key, init);
    },
    status: function status() {
        var json = storage.getItem('user');
        if (json == '' || !json.hasOwnProperty('accessKey') || !json.accessKey || json.accessKey == '') {
            return false;
        } else {
            return true;
        }
    },
    set: function set(data) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            storage.init();
            json = localStorage.getItem(key);
        }
        json = JSON.parse(json);
        json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, json, data);
        json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(json);
        localStorage.setItem(key, json);
    },
    setItem: function setItem(name, data) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            storage.init();
            json = localStorage.getItem(key);
        }
        json = JSON.parse(json);
        var temp = json[name];
        temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, temp, data);
        json[name] = temp;
        json = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(json);
        localStorage.setItem(key, json);
    },
    getItem: function getItem(name) {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            return '';
        }
        json = JSON.parse(json);
        if (json[name] != '0' && (!json[name] || json[name] == '')) {
            return '';
        }
        return json[name];
    },
    get: function get() {
        var json = localStorage.getItem(key);
        if (!json || json == '') {
            return '';
        }
        json = JSON.parse(json);
        return json;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ })
],[199]);


// WEBPACK FOOTER //
// static/js/app.f858bee3f609b587fbbc.js